/* Generated by ai2react v0.102.0 - 2021-12-23 02:23 */
/* ai file: odontologia.ai */

import { makeAi2React } from 'ai2react'
import img0 from '././img/odontologia-large.svg'
import img1 from '././img/odontologia-mobile.svg'

const styles = `
  #g-odontologia-box ,
  #g-odontologia-box .g-artboard {
    margin:0 auto;
  }
  #g-odontologia-box p {
    margin:0;
  }
  #g-odontologia-box .g-aiAbs {
    position:absolute;
  }
  #g-odontologia-box .g-aiImg {
    position:absolute;
    top:0;
    display:block;
    width:100% !important;
  }
  #g-odontologia-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-odontologia-box .g-aiPointText p { white-space: nowrap; }
  #g-odontologia-large {
    position:relative;
    overflow:hidden;
  }
  #g-odontologia-large p {
    font-family:Inter, sans-serif;
    font-weight:normal;
    line-height:13px;
    height:auto;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:11px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    position:static;
  }
  #g-odontologia-large .g-pstyle0 {
    line-height:11px;
    height:11px;
    letter-spacing:-0.019em;
    font-size:9px;
  }
  #g-odontologia-large .g-pstyle1 {
    font-weight:800;
    line-height:11px;
    height:11px;
    letter-spacing:0em;
    font-size:9px;
  }
  #g-odontologia-large .g-pstyle2 {
    font-weight:800;
    line-height:11px;
    height:11px;
    letter-spacing:-0.019em;
    font-size:9px;
  }
  #g-odontologia-large .g-pstyle3 {
    font-weight:800;
    line-height:15px;
    height:15px;
    letter-spacing:-0.019em;
    font-size:12px;
  }
  #g-odontologia-large .g-pstyle4 {
    font-weight:800;
    line-height:11px;
    height:11px;
    letter-spacing:-0.02em;
    font-size:9px;
  }
  #g-odontologia-large .g-pstyle5 {
    height:13px;
  }
  #g-odontologia-large .g-pstyle6 {
    font-weight:800;
    height:13px;
  }
  #g-odontologia-large .g-pstyle7 {
    height:13px;
    letter-spacing:0em;
  }
  #g-odontologia-large .g-pstyle8 {
    font-weight:800;
    height:13px;
    letter-spacing:-0.03em;
  }
  #g-odontologia-large .g-pstyle9 {
    height:13px;
    letter-spacing:-0.03em;
  }
  #g-odontologia-large .g-pstyle10 {
    font-weight:800;
    height:13px;
    letter-spacing:-0.043em;
  }
  #g-odontologia-large .g-pstyle11 {
    letter-spacing:-0.03em;
  }
  #g-odontologia-large .g-cstyle0 {
    letter-spacing:-0.02em;
  }
  #g-odontologia-large .g-cstyle1 {
    letter-spacing:0em;
  }
  #g-odontologia-large .g-cstyle2 {
    letter-spacing:-0.021em;
  }
  #g-odontologia-large .g-cstyle3 {
    letter-spacing:-0.019em;
  }
  #g-odontologia-large .g-cstyle4 {
    letter-spacing:-0.03em;
  }
  #g-odontologia-large .g-cstyle5 {
    letter-spacing:-0.034em;
  }
  #g-odontologia-large .g-cstyle6 {
    letter-spacing:-0.029em;
  }
  #g-odontologia-large .g-cstyle7 {
    letter-spacing:-0.084em;
  }
  #g-odontologia-large .g-cstyle8 {
    letter-spacing:-0.036em;
  }
  #g-odontologia-large .g-cstyle9 {
    letter-spacing:-0.052em;
  }
  #g-odontologia-large .g-cstyle10 {
    letter-spacing:-0.043em;
  }
  #g-odontologia-large .g-cstyle11 {
    letter-spacing:-0.047em;
  }
  #g-odontologia-large .g-cstyle12 {
    letter-spacing:-0.11em;
  }
  #g-odontologia-large .g-cstyle13 {
    letter-spacing:-0.121em;
  }
  #g-odontologia-large .g-cstyle14 {
    letter-spacing:-0.04em;
  }
  #g-odontologia-large .g-cstyle15 {
    letter-spacing:-0.041em;
  }
  #g-odontologia-large .g-cstyle16 {
    letter-spacing:-0.086em;
  }
  #g-odontologia-large .g-cstyle17 {
    letter-spacing:-0.124em;
  }
  #g-odontologia-large .g-cstyle18 {
    letter-spacing:-0.037em;
  }
  #g-odontologia-large .g-cstyle19 {
    letter-spacing:-0.032em;
  }
  #g-odontologia-large .g-cstyle20 {
    letter-spacing:-0.039em;
  }
  #g-odontologia-large .g-cstyle21 {
    letter-spacing:-0.042em;
  }
  #g-odontologia-large .g-cstyle22 {
    letter-spacing:-0.035em;
  }
  #g-odontologia-large .g-cstyle23 {
    letter-spacing:-0.116em;
  }
  #g-odontologia-large .g-cstyle24 {
    letter-spacing:-0.033em;
  }
  #g-odontologia-mobile {
    position:relative;
    overflow:hidden;
  }
  #g-odontologia-mobile p {
    font-family:Inter, sans-serif;
    font-weight:normal;
    line-height:13px;
    height:auto;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:11px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    position:static;
  }
  #g-odontologia-mobile .g-pstyle0 {
    font-weight:800;
    line-height:11px;
    height:11px;
    letter-spacing:-0.019em;
    font-size:9px;
  }
  #g-odontologia-mobile .g-pstyle1 {
    font-weight:800;
    line-height:15px;
    height:15px;
    letter-spacing:-0.019em;
    font-size:12px;
  }
  #g-odontologia-mobile .g-pstyle2 {
    height:13px;
  }
  #g-odontologia-mobile .g-pstyle3 {
    font-weight:800;
    height:13px;
  }
  #g-odontologia-mobile .g-pstyle4 {
    font-weight:800;
    height:13px;
    letter-spacing:-0.03em;
  }
  #g-odontologia-mobile .g-pstyle5 {
    height:13px;
    letter-spacing:-0.052em;
  }
  #g-odontologia-mobile .g-pstyle6 {
    height:13px;
    letter-spacing:-0.03em;
  }
  #g-odontologia-mobile .g-pstyle7 {
    line-height:11px;
    height:11px;
    letter-spacing:-0.019em;
    font-size:9px;
  }
  #g-odontologia-mobile .g-pstyle8 {
    font-weight:800;
    line-height:11px;
    height:11px;
    letter-spacing:0em;
    font-size:9px;
  }
  #g-odontologia-mobile .g-pstyle9 {
    font-weight:800;
    line-height:11px;
    height:11px;
    letter-spacing:-0.02em;
    font-size:9px;
  }
  #g-odontologia-mobile .g-pstyle10 {
    height:13px;
    letter-spacing:0em;
  }
  #g-odontologia-mobile .g-pstyle11 {
    letter-spacing:-0.03em;
  }
  #g-odontologia-mobile .g-cstyle0 {
    letter-spacing:-0.02em;
  }
  #g-odontologia-mobile .g-cstyle1 {
    letter-spacing:0em;
  }
  #g-odontologia-mobile .g-cstyle2 {
    letter-spacing:-0.021em;
  }
  #g-odontologia-mobile .g-cstyle3 {
    letter-spacing:-0.03em;
  }
  #g-odontologia-mobile .g-cstyle4 {
    letter-spacing:-0.034em;
  }
  #g-odontologia-mobile .g-cstyle5 {
    letter-spacing:-0.052em;
  }
  #g-odontologia-mobile .g-cstyle6 {
    letter-spacing:-0.029em;
  }
  #g-odontologia-mobile .g-cstyle7 {
    letter-spacing:-0.043em;
  }
  #g-odontologia-mobile .g-cstyle8 {
    letter-spacing:-0.047em;
  }
  #g-odontologia-mobile .g-cstyle9 {
    letter-spacing:-0.036em;
  }
  #g-odontologia-mobile .g-cstyle10 {
    letter-spacing:-0.11em;
  }
  #g-odontologia-mobile .g-cstyle11 {
    letter-spacing:-0.121em;
  }
  #g-odontologia-mobile .g-cstyle12 {
    letter-spacing:-0.04em;
  }
  #g-odontologia-mobile .g-cstyle13 {
    letter-spacing:-0.041em;
  }
  #g-odontologia-mobile .g-cstyle14 {
    letter-spacing:-0.086em;
  }
  #g-odontologia-mobile .g-cstyle15 {
    letter-spacing:-0.124em;
  }
  #g-odontologia-mobile .g-cstyle16 {
    letter-spacing:-0.037em;
  }
  #g-odontologia-mobile .g-cstyle17 {
    letter-spacing:-0.032em;
  }
  #g-odontologia-mobile .g-cstyle18 {
    letter-spacing:-0.039em;
  }
  #g-odontologia-mobile .g-cstyle19 {
    letter-spacing:-0.035em;
  }
  #g-odontologia-mobile .g-cstyle20 {
    letter-spacing:-0.116em;
  }
  #g-odontologia-mobile .g-cstyle21 {
    letter-spacing:-0.033em;
  }
  #g-odontologia-mobile .g-cstyle22 {
    letter-spacing:-0.019em;
  }
  #g-odontologia-mobile .g-cstyle23 {
    letter-spacing:-0.084em;
  }
  #g-odontologia-mobile .g-cstyle24 {
    letter-spacing:-0.042em;
  }

`

const html = props => `
<div id="g-odontologia-box" class="ai2html">


  <!-- Artboard: large -->
  <div id="g-odontologia-large" class="g-artboard" style="width:940px; height:359.549999999999px;" data-aspect-ratio="2.614" data-min-width="940">
<div style=""></div>
    <img id="g-odontologia-large-img" class="g-aiImg" alt="" src="${img0}"/>
    <div id="g-ai0-1" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:5.7323%;margin-top:-6.6px;left:53.7685%;width:40px;">
      <p class="g-pstyle0"><span class="g-cstyle0">P</span>D<span class="g-cstyle1">T</span></p>
    </div>
    <div id="g-ai0-2" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:5.7323%;margin-top:-6.6px;left:55.7603%;width:24px;">
      <p class="g-pstyle1"> </p>
    </div>
    <div id="g-ai0-3" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:5.7323%;margin-top:-6.6px;left:58.6728%;width:40px;">
      <p class="g-pstyle0"><span class="g-cstyle0">P</span>D<span class="g-cstyle1">T</span></p>
    </div>
    <div id="g-ai0-4" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:5.7323%;margin-top:-6.6px;left:60.6644%;width:24px;">
      <p class="g-pstyle1"> </p>
    </div>
    <div id="g-ai0-5" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:5.7323%;margin-top:-6.6px;left:63.5688%;width:40px;">
      <p class="g-pstyle0"><span class="g-cstyle0">P</span>D<span class="g-cstyle1">T</span></p>
    </div>
    <div id="g-ai0-6" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:5.7323%;margin-top:-6.6px;left:65.5606%;width:24px;">
      <p class="g-pstyle1"> </p>
    </div>
    <div id="g-ai0-7" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:5.7323%;margin-top:-6.6px;left:68.4726%;width:40px;">
      <p class="g-pstyle0">PD<span class="g-cstyle1">T</span></p>
    </div>
    <div id="g-ai0-8" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:5.7323%;margin-top:-6.6px;left:70.4647%;width:24px;">
      <p class="g-pstyle1"> </p>
    </div>
    <div id="g-ai0-9" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:5.7323%;margin-top:-6.6px;left:73.4563%;width:44px;">
      <p class="g-pstyle2"> NE<span class="g-cstyle1">M</span></p>
    </div>
    <div id="g-ai0-10" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:5.7323%;margin-top:-6.6px;left:79.0427%;width:60px;">
      <p class="g-pstyle2"><span class="g-cstyle0">Ra</span>nkin<span class="g-cstyle0">g</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-11" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:5.7323%;margin-top:-6.6px;left:95.4226%;width:59px;">
      <p class="g-pstyle2">Ar<span class="g-cstyle0">a</span>nce<span class="g-cstyle0">l</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-12" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:8.5421%;margin-top:-8.7px;left:2.0299%;width:91px;">
      <p class="g-pstyle3"><span class="g-cstyle0">U</span>ni<span class="g-cstyle0">ve</span>r<span class="g-cstyle0">s</span>i<span class="g-cstyle0">d</span>a<span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai0-13" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:8.7916%;margin-top:-6.6px;left:22.1143%;width:45px;">
      <p class="g-pstyle2">Sed<span class="g-cstyle1">e</span></p>
    </div>
    <div id="g-ai0-14" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:8.7916%;margin-top:-6.6px;left:29.9307%;width:63px;">
      <p class="g-pstyle2">M<span class="g-cstyle2">í</span>n <span class="g-cstyle0">P</span>on<span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai0-15" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:8.7916%;margin-top:-6.6px;left:37.5486%;width:70px;">
      <p class="g-pstyle2">Prom P<span class="g-cstyle0">o</span>n<span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai0-16" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:8.7916%;margin-top:-6.6px;left:45.9286%;width:65px;">
      <p class="g-pstyle2">M<span class="g-cstyle0">á</span>x Po<span class="g-cstyle0">n</span><span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai0-17" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:8.7916%;margin-top:-6.6px;left:85.8194%;width:64px;">
      <p class="g-pstyle2"><span class="g-cstyle0">V</span>acant<span class="g-cstyle0">e</span><span class="g-cstyle1">s</span></p>
    </div>
    <div id="g-ai0-18" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:8.7916%;margin-top:-6.6px;left:53.7209%;width:41px;">
      <p class="g-pstyle2">len<span class="g-cstyle1">g</span></p>
    </div>
    <div id="g-ai0-19" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:8.7916%;margin-top:-6.6px;left:58.7204%;width:39px;">
      <p class="g-pstyle4"><span class="g-cstyle3">m</span>a<span class="g-cstyle1">t</span></p>
    </div>
    <div id="g-ai0-20" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:8.7916%;margin-top:-6.6px;left:63.5767%;width:41px;">
      <p class="g-pstyle2">cie<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai0-21" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:8.7916%;margin-top:-6.6px;left:68.5918%;width:39px;">
      <p class="g-pstyle2">his<span class="g-cstyle1">t</span></p>
    </div>
    <div id="g-ai0-22" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:8.7916%;margin-top:-6.6px;left:79.6775%;width:47px;">
      <p class="g-pstyle2">not<span class="g-cstyle0">a</span><span class="g-cstyle1">s</span></p>
    </div>
    <div id="g-ai0-23" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:8.7916%;margin-top:-6.6px;left:93.9862%;width:70px;">
      <p class="g-pstyle2">referen<span class="g-cstyle0">c</span>i<span class="g-cstyle0">a</span><span class="g-cstyle1">l</span></p>
    </div>
    <div id="g-ai0-24" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:15.9677%;margin-top:-7.4px;left:1.9902%;width:87px;">
      <p class="g-pstyle5"><span class="g-cstyle4">P</span>UC <span class="g-cstyle4">d</span>e<span class="g-cstyle4"> </span>C<span class="g-cstyle4">h</span>il<span class="g-cstyle4">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-25" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.2458%;margin-top:-7.4px;left:21.3051%;width:65px;">
      <p class="g-pstyle5">Sant<span class="g-cstyle4">ia</span>go<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-26" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.2458%;margin-top:-7.4px;left:30.502%;width:57px;">
      <p class="g-pstyle6">72<span class="g-cstyle4">1</span>,<span class="g-cstyle4">5</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-27" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.2458%;margin-top:-7.4px;left:38.5803%;width:58px;">
      <p class="g-pstyle6">73<span class="g-cstyle5">8</span>,<span class="g-cstyle4">57</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-28" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.2458%;margin-top:-7.4px;left:46.6585%;width:58px;">
      <p class="g-pstyle6">77<span class="g-cstyle4">5</span>,3<span class="g-cstyle4">5</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-29" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.2458%;margin-top:-7.4px;left:53.8002%;width:43px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>0%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-30" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.2458%;margin-top:-7.4px;left:58.6488%;width:45px;">
      <p class="g-pstyle5">20%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-31" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.2458%;margin-top:-7.4px;left:63.5846%;width:45px;">
      <p class="g-pstyle5">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-32" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.2458%;margin-top:-7.4px;left:69.4807%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-33" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.2458%;margin-top:-7.4px;left:73.6703%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-34" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.2458%;margin-top:-7.4px;left:79.9553%;width:45px;">
      <p class="g-pstyle6">2<span class="g-cstyle4">5</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-35" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.2458%;margin-top:-7.4px;left:87.3986%;width:38px;">
      <p class="g-pstyle8"><span class="g-cstyle6">6</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-36" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.2458%;margin-top:-7.4px;left:93.0773%;width:81px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span><span class="g-cstyle7">7</span>.35<span class="g-cstyle4">2</span><span class="g-cstyle8">.</span>0<span class="g-cstyle4">00</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-37" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:20.1396%;margin-top:-7.4px;left:1.9902%;width:76px;">
      <p class="g-pstyle5"><span class="g-cstyle9">U</span>. <span class="g-cstyle4">d</span>e C<span class="g-cstyle4">h</span>il<span class="g-cstyle4">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-38" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.4177%;margin-top:-7.4px;left:21.3051%;width:65px;">
      <p class="g-pstyle5">Sant<span class="g-cstyle4">ia</span>go<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-39" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.4177%;margin-top:-7.4px;left:30.4386%;width:60px;">
      <p class="g-pstyle6">69<span class="g-cstyle4">5</span>,<span class="g-cstyle4">2</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-40" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.4177%;margin-top:-7.4px;left:38.5882%;width:56px;">
      <p class="g-pstyle8"><span class="g-cstyle6">7</span>11<span class="g-cstyle6">,</span>54<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-41" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.4177%;margin-top:-7.4px;left:46.5631%;width:60px;">
      <p class="g-pstyle8"><span class="g-cstyle10">7</span>4<span class="g-cstyle11">9</span><span class="g-cstyle8">,</span>0<span class="g-cstyle6">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-42" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.4177%;margin-top:-7.4px;left:53.8322%;width:43px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-43" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.4177%;margin-top:-7.4px;left:58.6488%;width:45px;">
      <p class="g-pstyle5">20%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-44" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.4177%;margin-top:-7.4px;left:63.5846%;width:45px;">
      <p class="g-pstyle5">35%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-45" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.4177%;margin-top:-7.4px;left:69.4807%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-46" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.4177%;margin-top:-7.4px;left:73.7181%;width:43px;">
      <p class="g-pstyle9">10<span class="g-cstyle6">%</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-47" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.4177%;margin-top:-7.4px;left:79.9235%;width:46px;">
      <p class="g-pstyle6">2<span class="g-cstyle4">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-48" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.4177%;margin-top:-7.4px;left:87.0971%;width:43px;">
      <p class="g-pstyle8"><span class="g-cstyle6">1</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-49" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.4177%;margin-top:-7.4px;left:92.9899%;width:81px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span>6.<span class="g-cstyle4">4</span>16<span class="g-cstyle8">.</span><span class="g-cstyle4">7</span>0<span class="g-cstyle4">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-50" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:24.3115%;margin-top:-7.4px;left:1.9902%;width:77px;">
      <p class="g-pstyle5"><span class="g-cstyle9">U</span>. <span class="g-cstyle4">d</span>e <span class="g-cstyle12">T</span><span class="g-cstyle4">a</span>lc<span class="g-cstyle4">a</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-51" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.3115%;margin-top:-7.4px;left:22.1303%;width:49px;">
      <p class="g-pstyle5"><span class="g-cstyle13">T</span>a<span class="g-cstyle4">l</span>ca<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-52" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.3115%;margin-top:-7.4px;left:30.4465%;width:59px;">
      <p class="g-pstyle6">69<span class="g-cstyle4">1</span>,<span class="g-cstyle4">8</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-53" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.3115%;margin-top:-7.4px;left:38.6358%;width:54px;">
      <p class="g-pstyle8"><span class="g-cstyle6">7</span>15<span class="g-cstyle6">,</span>11<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-54" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.3115%;margin-top:-7.4px;left:46.6107%;width:59px;">
      <p class="g-pstyle6"><span class="g-cstyle10">7</span><span class="g-cstyle4">4</span><span class="g-cstyle5">3</span><span class="g-cstyle14">,</span>95<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-55" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.3115%;margin-top:-7.4px;left:53.8002%;width:43px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>0%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-56" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.3115%;margin-top:-7.4px;left:58.6884%;width:45px;">
      <p class="g-pstyle5">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-57" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.3115%;margin-top:-7.4px;left:63.6322%;width:43px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-58" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.3115%;margin-top:-7.4px;left:69.4807%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-59" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.3115%;margin-top:-7.4px;left:73.7102%;width:45px;">
      <p class="g-pstyle5">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-60" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.3115%;margin-top:-7.4px;left:79.9553%;width:45px;">
      <p class="g-pstyle6">2<span class="g-cstyle4">5</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-61" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.3115%;margin-top:-7.4px;left:87.4145%;width:38px;">
      <p class="g-pstyle8"><span class="g-cstyle6">5</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-62" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.3115%;margin-top:-7.4px;left:93.0218%;width:83px;">
      <p class="g-pstyle8">$<span class="g-cstyle6">5</span>.<span class="g-cstyle6">5</span>5<span class="g-cstyle6">3</span><span class="g-cstyle8">.</span>0<span class="g-cstyle6">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-63" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.2052%;margin-top:-7.4px;left:68.5281%;width:41px;">
      <p class="g-pstyle9">10%</p>
    </div>
    <div id="g-ai0-64" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.2052%;margin-top:-7.4px;left:20.96%;width:70px;">
      <p class="g-pstyle5">Valparaíso</p>
    </div>
    <div id="g-ai0-65" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.2052%;margin-top:-7.4px;left:30.4465%;width:56px;">
      <p class="g-pstyle6">691.40</p>
    </div>
    <div id="g-ai0-66" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.2052%;margin-top:-7.4px;left:38.6358%;width:55px;">
      <p class="g-pstyle6">713.90</p>
    </div>
    <div id="g-ai0-67" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.2052%;margin-top:-7.4px;left:46.6107%;width:57px;">
      <p class="g-pstyle10">764.30</p>
    </div>
    <div id="g-ai0-68" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.2052%;margin-top:-7.4px;left:53.8002%;width:40px;">
      <p class="g-pstyle9">15%</p>
    </div>
    <div id="g-ai0-69" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.2052%;margin-top:-7.4px;left:58.6884%;width:40px;">
      <p class="g-pstyle5">15%</p>
    </div>
    <div id="g-ai0-70" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.2052%;margin-top:-7.4px;left:63.6322%;width:41px;">
      <p class="g-pstyle9">10%</p>
    </div>
    <div id="g-ai0-71" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.2052%;margin-top:-7.4px;left:69.4807%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-72" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.2052%;margin-top:-7.4px;left:73.7102%;width:42px;">
      <p class="g-pstyle5">30%</p>
    </div>
    <div id="g-ai0-73" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.2052%;margin-top:-7.4px;left:79.9553%;width:44px;">
      <p class="g-pstyle6">30%</p>
    </div>
    <div id="g-ai0-74" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.2052%;margin-top:-7.4px;left:87.4145%;width:34px;">
      <p class="g-pstyle6">72</p>
    </div>
    <div id="g-ai0-75" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.2052%;margin-top:-7.4px;left:93.0218%;width:81px;">
      <p class="g-pstyle8">$5.603.000</p>
    </div>
    <div id="g-ai0-76" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:28.4833%;margin-top:-7.4px;left:1.9902%;width:103px;">
      <p class="g-pstyle5"><span class="g-cstyle9">U</span>. <span class="g-cstyle4">d</span>e Valparaíso*</p>
    </div>
    <div id="g-ai0-77" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.3771%;margin-top:-7.4px;left:21.3051%;width:65px;">
      <p class="g-pstyle5">Sant<span class="g-cstyle4">ia</span>go<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-78" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.3771%;margin-top:-7.4px;left:30.4386%;width:60px;">
      <p class="g-pstyle6">68<span class="g-cstyle4">5</span><span class="g-cstyle15">,</span>90<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-79" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.3771%;margin-top:-7.4px;left:38.5327%;width:58px;">
      <p class="g-pstyle8"><span class="g-cstyle6">7</span>0<span class="g-cstyle5">8</span><span class="g-cstyle8">,</span><span class="g-cstyle6">0</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-80" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.3771%;margin-top:-7.4px;left:46.5948%;width:60px;">
      <p class="g-pstyle8"><span class="g-cstyle6">7</span>55<span class="g-cstyle8">,</span><span class="g-cstyle6">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-81" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.3771%;margin-top:-7.4px;left:53.8322%;width:43px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-82" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.3771%;margin-top:-7.4px;left:58.6567%;width:45px;">
      <p class="g-pstyle5">3<span class="g-cstyle4">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-83" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.3771%;margin-top:-7.4px;left:63.6322%;width:43px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-84" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.3771%;margin-top:-7.4px;left:69.4807%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-85" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.3771%;margin-top:-7.4px;left:73.6703%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-86" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.3771%;margin-top:-7.4px;left:79.9235%;width:46px;">
      <p class="g-pstyle6">2<span class="g-cstyle4">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-87" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.3771%;margin-top:-7.4px;left:87.4066%;width:37px;">
      <p class="g-pstyle8"><span class="g-cstyle6">4</span>2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-88" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.3771%;margin-top:-7.4px;left:95.4363%;width:58px;">
      <p class="g-pstyle6">287 <span class="g-cstyle4">U</span>F<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-89" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:32.6552%;margin-top:-7.4px;left:1.9902%;width:98px;">
      <p class="g-pstyle5"><span class="g-cstyle9">U</span>. <span class="g-cstyle4">d</span>e <span class="g-cstyle4">lo</span>s <span class="g-cstyle4">A</span>n<span class="g-cstyle4">d</span>e<span class="g-cstyle4">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-90" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.549%;margin-top:-7.4px;left:20.4163%;width:79px;">
      <p class="g-pstyle5"><span class="g-cstyle4">C</span>oncep<span class="g-cstyle4">ci</span>ón<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-91" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.549%;margin-top:-7.4px;left:30.4941%;width:58px;">
      <p class="g-pstyle6">67<span class="g-cstyle4">5</span>,<span class="g-cstyle4">1</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-92" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.549%;margin-top:-7.4px;left:38.5009%;width:60px;">
      <p class="g-pstyle6">696,<span class="g-cstyle4">8</span>3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-93" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.549%;margin-top:-7.4px;left:46.6027%;width:58px;">
      <p class="g-pstyle8"><span class="g-cstyle10">7</span>4<span class="g-cstyle16">7</span><span class="g-cstyle6">,</span>40<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-94" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.549%;margin-top:-7.4px;left:53.7843%;width:45px;">
      <p class="g-pstyle5">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-95" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.549%;margin-top:-7.4px;left:58.6884%;width:45px;">
      <p class="g-pstyle5">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-96" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.549%;margin-top:-7.4px;left:63.6005%;width:43px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>0%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-97" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.549%;margin-top:-7.4px;left:69.4807%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-98" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.549%;margin-top:-7.4px;left:73.7498%;width:43px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-99" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.549%;margin-top:-7.4px;left:79.9553%;width:45px;">
      <p class="g-pstyle6">2<span class="g-cstyle4">5</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-100" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.549%;margin-top:-7.4px;left:87.4544%;width:36px;">
      <p class="g-pstyle6">75<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-101" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.549%;margin-top:-7.4px;left:93.0456%;width:80px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span>6<span class="g-cstyle8">.</span>97<span class="g-cstyle4">6</span><span class="g-cstyle8">.</span><span class="g-cstyle4">01</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-102" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:36.8271%;margin-top:-7.4px;left:1.9902%;width:108px;">
      <p class="g-pstyle5"><span class="g-cstyle9">U</span>. <span class="g-cstyle4">d</span>e C<span class="g-cstyle4">o</span>n<span class="g-cstyle4">c</span>epc<span class="g-cstyle4">ió</span>n<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-103" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.7209%;margin-top:-7.4px;left:21.3922%;width:61px;">
      <p class="g-pstyle5"><span class="g-cstyle17">T</span>em<span class="g-cstyle4">u</span>c<span class="g-cstyle4">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-104" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.7209%;margin-top:-7.4px;left:30.5021%;width:59px;">
      <p class="g-pstyle6">6<span class="g-cstyle4">4</span><span class="g-cstyle16">7</span>,35<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-105" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.7209%;margin-top:-7.4px;left:38.5327%;width:59px;">
      <p class="g-pstyle6">675<span class="g-cstyle8">,</span><span class="g-cstyle4">0</span>2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-106" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.7209%;margin-top:-7.4px;left:46.6267%;width:59px;">
      <p class="g-pstyle6">73<span class="g-cstyle4">2</span><span class="g-cstyle14">,</span>9<span class="g-cstyle4">5</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-107" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.7209%;margin-top:-7.4px;left:53.8322%;width:43px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-108" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.7209%;margin-top:-7.4px;left:58.6567%;width:45px;">
      <p class="g-pstyle5">3<span class="g-cstyle4">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-109" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.7209%;margin-top:-7.4px;left:63.6005%;width:43px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>0%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-110" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.7209%;margin-top:-7.4px;left:69.4807%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-111" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.7209%;margin-top:-7.4px;left:73.7181%;width:43px;">
      <p class="g-pstyle9">10<span class="g-cstyle6">%</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-112" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.7209%;margin-top:-7.4px;left:79.9632%;width:46px;">
      <p class="g-pstyle6">3<span class="g-cstyle4">5</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-113" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.7209%;margin-top:-7.4px;left:87.4224%;width:37px;">
      <p class="g-pstyle6">70<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-114" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.7209%;margin-top:-7.4px;left:93.0852%;width:81px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span>5<span class="g-cstyle8">.</span>78<span class="g-cstyle7">7</span><span class="g-cstyle8">.</span><span class="g-cstyle4">00</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-115" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:40.999%;margin-top:-7.4px;left:1.9902%;width:106px;">
      <p class="g-pstyle5"><span class="g-cstyle9">U</span>. <span class="g-cstyle4">d</span>e L<span class="g-cstyle4">a</span> <span class="g-cstyle18">F</span><span class="g-cstyle19">r</span><span class="g-cstyle4">on</span>te<span class="g-cstyle4">ra</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-116" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.8927%;margin-top:-7.4px;left:21.3051%;width:65px;">
      <p class="g-pstyle5">Sant<span class="g-cstyle4">ia</span>go<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-117" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.8927%;margin-top:-7.4px;left:30.4544%;width:60px;">
      <p class="g-pstyle6">63<span class="g-cstyle4">5</span>,<span class="g-cstyle4">2</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-118" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.8927%;margin-top:-7.4px;left:38.5723%;width:57px;">
      <p class="g-pstyle6">671<span class="g-cstyle10">,</span>70<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-119" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.8927%;margin-top:-7.4px;left:46.6186%;width:59px;">
      <p class="g-pstyle6">73<span class="g-cstyle4">5</span>,<span class="g-cstyle4">5</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-120" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.8927%;margin-top:-7.4px;left:53.7526%;width:45px;">
      <p class="g-pstyle5">20%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-121" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.8927%;margin-top:-7.4px;left:58.6884%;width:45px;">
      <p class="g-pstyle5">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-122" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.8927%;margin-top:-7.4px;left:63.6322%;width:43px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-123" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.8927%;margin-top:-7.4px;left:68.5281%;width:43px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-124" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.8927%;margin-top:-7.4px;left:73.6703%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-125" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.8927%;margin-top:-7.4px;left:79.9235%;width:46px;">
      <p class="g-pstyle6">2<span class="g-cstyle4">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-126" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.8927%;margin-top:-7.4px;left:87.0971%;width:43px;">
      <p class="g-pstyle8"><span class="g-cstyle6">1</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-127" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.8927%;margin-top:-7.4px;left:95.1326%;width:59px;">
      <p class="g-pstyle6">3<span class="g-cstyle4">0</span>5 UF<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-128" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:44.8927%;margin-top:-7.4px;left:1.9902%;width:107px;">
      <p class="g-pstyle5"><span class="g-cstyle9">U</span>. <span class="g-cstyle4">d</span>el De<span class="g-cstyle4">s</span>a<span class="g-cstyle4">r</span><span class="g-cstyle19">r</span><span class="g-cstyle4">o</span>ll<span class="g-cstyle4">o*</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-129" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.0646%;margin-top:-7.4px;left:21.5827%;width:60px;">
      <p class="g-pstyle5"><span class="g-cstyle9">V</span>a<span class="g-cstyle4">l</span>div<span class="g-cstyle4">ia</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-130" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.0646%;margin-top:-7.4px;left:30.4861%;width:58px;">
      <p class="g-pstyle6">63<span class="g-cstyle8">4</span>,<span class="g-cstyle4">15</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-131" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.0646%;margin-top:-7.4px;left:38.5009%;width:59px;">
      <p class="g-pstyle6">67<span class="g-cstyle20">0</span>,<span class="g-cstyle4">4</span>2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-132" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.0646%;margin-top:-7.4px;left:46.5869%;width:59px;">
      <p class="g-pstyle6">73<span class="g-cstyle11">9</span>,8<span class="g-cstyle4">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-133" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.0646%;margin-top:-7.4px;left:53.7526%;width:45px;">
      <p class="g-pstyle5">20%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-134" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.0646%;margin-top:-7.4px;left:58.7281%;width:43px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-135" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.0646%;margin-top:-7.4px;left:63.6322%;width:43px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-136" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.0646%;margin-top:-7.4px;left:69.4807%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-137" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.0646%;margin-top:-7.4px;left:73.7498%;width:43px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-138" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.0646%;margin-top:-7.4px;left:79.9632%;width:46px;">
      <p class="g-pstyle6">3<span class="g-cstyle4">5</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-139" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.0646%;margin-top:-7.4px;left:87.4066%;width:37px;">
      <p class="g-pstyle6">66<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-140" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.0646%;margin-top:-7.4px;left:92.9266%;width:82px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span>6<span class="g-cstyle8">.</span><span class="g-cstyle4">0</span>16<span class="g-cstyle8">.</span><span class="g-cstyle4">00</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-141" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:49.0646%;margin-top:-7.4px;left:1.9902%;width:111px;">
      <p class="g-pstyle5"><span class="g-cstyle9">U</span>. Aust<span class="g-cstyle4">r</span>a<span class="g-cstyle4">l </span>d<span class="g-cstyle4">e</span> C<span class="g-cstyle4">h</span>il<span class="g-cstyle4">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-142" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.2365%;margin-top:-7.4px;left:68.4964%;width:43px;">
      <p class="g-pstyle9">10<span class="g-cstyle6">%</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-143" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.2365%;margin-top:-7.4px;left:21.3051%;width:65px;">
      <p class="g-pstyle5">Sant<span class="g-cstyle4">ia</span>go<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-144" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.2365%;margin-top:-7.4px;left:30.4386%;width:60px;">
      <p class="g-pstyle8"><span class="g-cstyle6">6</span>0<span class="g-cstyle6">6,</span>25<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-145" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.2365%;margin-top:-7.4px;left:38.5247%;width:60px;">
      <p class="g-pstyle6">6<span class="g-cstyle4">5</span><span class="g-cstyle5">3</span><span class="g-cstyle8">,</span>66<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-146" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.2365%;margin-top:-7.4px;left:46.6506%;width:56px;">
      <p class="g-pstyle8"><span class="g-cstyle6">7</span>1<span class="g-cstyle5">3</span><span class="g-cstyle6">,</span>10<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-147" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.2365%;margin-top:-7.4px;left:53.7526%;width:45px;">
      <p class="g-pstyle5">20%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-148" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.2365%;margin-top:-7.4px;left:58.6329%;width:45px;">
      <p class="g-pstyle5">40%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-149" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.2365%;margin-top:-7.4px;left:63.6005%;width:43px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>0%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-150" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.2365%;margin-top:-7.4px;left:73.7181%;width:43px;">
      <p class="g-pstyle9">10<span class="g-cstyle6">%</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-151" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.2365%;margin-top:-7.4px;left:79.9235%;width:46px;">
      <p class="g-pstyle6">2<span class="g-cstyle4">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-152" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.2365%;margin-top:-7.4px;left:87.3986%;width:38px;">
      <p class="g-pstyle8"><span class="g-cstyle6">6</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-153" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.2365%;margin-top:-7.4px;left:93.0931%;width:80px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span><span class="g-cstyle7">7</span><span class="g-cstyle8">.</span>9<span class="g-cstyle4">0</span><span class="g-cstyle21">9</span>.<span class="g-cstyle4">1</span>60<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-154" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:53.2365%;margin-top:-7.4px;left:1.9902%;width:72px;">
      <p class="g-pstyle5"><span class="g-cstyle9">U</span>. <span class="g-cstyle4">M</span>ay<span class="g-cstyle4">o</span>r*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-155" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4084%;margin-top:-7.4px;left:21.3051%;width:65px;">
      <p class="g-pstyle5">Sant<span class="g-cstyle4">ia</span>go<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-156" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4084%;margin-top:-7.4px;left:30.4068%;width:61px;">
      <p class="g-pstyle8"><span class="g-cstyle6">6</span>0<span class="g-cstyle5">3</span>,4<span class="g-cstyle6">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-157" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4084%;margin-top:-7.4px;left:38.5327%;width:59px;">
      <p class="g-pstyle6">63<span class="g-cstyle5">8</span>,<span class="g-cstyle4">52</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-158" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4084%;margin-top:-7.4px;left:46.5393%;width:60px;">
      <p class="g-pstyle6">68<span class="g-cstyle4">5</span>,<span class="g-cstyle4">4</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-159" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4084%;margin-top:-7.4px;left:53.7843%;width:45px;">
      <p class="g-pstyle5">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-160" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4084%;margin-top:-7.4px;left:58.6329%;width:45px;">
      <p class="g-pstyle5">40%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-161" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4084%;margin-top:-7.4px;left:63.6322%;width:43px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-162" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4084%;margin-top:-7.4px;left:69.4807%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-163" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4084%;margin-top:-7.4px;left:73.7181%;width:43px;">
      <p class="g-pstyle9">10<span class="g-cstyle6">%</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-164" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4084%;margin-top:-7.4px;left:79.9473%;width:45px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-165" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4084%;margin-top:-7.4px;left:87.4224%;width:37px;">
      <p class="g-pstyle8"><span class="g-cstyle6">6</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-166" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.4084%;margin-top:-7.4px;left:92.9028%;width:83px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span>8<span class="g-cstyle8">.</span>7<span class="g-cstyle4">0</span>8<span class="g-cstyle8">.</span><span class="g-cstyle4">0</span>0<span class="g-cstyle4">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-167" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:57.4084%;margin-top:-7.4px;left:1.9902%;width:106px;">
      <p class="g-pstyle5"><span class="g-cstyle9">U</span>. Die<span class="g-cstyle4">go</span> P<span class="g-cstyle4">o</span>rt<span class="g-cstyle4">al</span>e<span class="g-cstyle4">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-168" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.5803%;margin-top:-7.4px;left:21.3051%;width:65px;">
      <p class="g-pstyle5">Sant<span class="g-cstyle4">ia</span>go<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-169" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.5803%;margin-top:-7.4px;left:30.4465%;width:59px;">
      <p class="g-pstyle8"><span class="g-cstyle6">6</span>0<span class="g-cstyle6">2,</span>10<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-170" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.5803%;margin-top:-7.4px;left:38.5089%;width:59px;">
      <p class="g-pstyle6">6<span class="g-cstyle4">2</span><span class="g-cstyle22">4</span><span class="g-cstyle4">,</span>23<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-171" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.5803%;margin-top:-7.4px;left:46.5472%;width:60px;">
      <p class="g-pstyle6">7<span class="g-cstyle4">0</span><span class="g-cstyle20">0</span><span class="g-cstyle8">,</span>60<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-172" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.5803%;margin-top:-7.4px;left:53.7526%;width:45px;">
      <p class="g-pstyle5">20%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-173" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.5803%;margin-top:-7.4px;left:58.6567%;width:45px;">
      <p class="g-pstyle5">3<span class="g-cstyle4">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-174" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.5803%;margin-top:-7.4px;left:63.6322%;width:43px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-175" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.5803%;margin-top:-7.4px;left:69.4807%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-176" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.5803%;margin-top:-7.4px;left:73.7102%;width:45px;">
      <p class="g-pstyle5">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-177" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.5803%;margin-top:-7.4px;left:79.9473%;width:45px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-178" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.5803%;margin-top:-7.4px;left:87.4145%;width:38px;">
      <p class="g-pstyle8"><span class="g-cstyle6">5</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-179" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.5803%;margin-top:-7.4px;left:92.8869%;width:84px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span>8.36<span class="g-cstyle18">0</span><span class="g-cstyle8">.</span><span class="g-cstyle4">0</span>0<span class="g-cstyle4">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-180" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:61.5803%;margin-top:-7.4px;left:1.9902%;width:91px;">
      <p class="g-pstyle9"><span class="g-cstyle9">U</span><span class="g-cstyle6">. </span>F<span class="g-cstyle6">in</span>is <span class="g-cstyle23">T</span>e<span class="g-cstyle6">rr</span>ae<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-181" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.7522%;margin-top:-7.4px;left:20.5591%;width:80px;">
      <p class="g-pstyle5">Ant<span class="g-cstyle24">o</span>fa<span class="g-cstyle4">g</span>asta<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-182" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.7522%;margin-top:-7.4px;left:30.4306%;width:60px;">
      <p class="g-pstyle6"><span class="g-cstyle4">5</span>9<span class="g-cstyle4">2</span><span class="g-cstyle8">,</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-183" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.7522%;margin-top:-7.4px;left:38.4771%;width:60px;">
      <p class="g-pstyle6">69<span class="g-cstyle4">2</span><span class="g-cstyle8">,</span>0<span class="g-cstyle4">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-184" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.7522%;margin-top:-7.4px;left:46.5472%;width:60px;">
      <p class="g-pstyle8"><span class="g-cstyle10">7</span>4<span class="g-cstyle5">8</span><span class="g-cstyle8">,</span><span class="g-cstyle6">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-185" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.7522%;margin-top:-7.4px;left:53.7526%;width:45px;">
      <p class="g-pstyle5">20%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-186" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.7522%;margin-top:-7.4px;left:58.6488%;width:45px;">
      <p class="g-pstyle5">20%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-187" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.7522%;margin-top:-7.4px;left:63.6005%;width:43px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>0%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-188" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.7522%;margin-top:-7.4px;left:69.4807%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-189" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.7522%;margin-top:-7.4px;left:73.7181%;width:43px;">
      <p class="g-pstyle9">10<span class="g-cstyle6">%</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-190" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.7522%;margin-top:-7.4px;left:79.8997%;width:47px;">
      <p class="g-pstyle6">4<span class="g-cstyle4">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-191" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.7522%;margin-top:-7.4px;left:87.3828%;width:38px;">
      <p class="g-pstyle8"><span class="g-cstyle6">4</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-192" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.7522%;margin-top:-7.4px;left:92.9345%;width:83px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span>5<span class="g-cstyle18">.</span>626<span class="g-cstyle8">.</span><span class="g-cstyle4">00</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-193" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:65.7522%;margin-top:-7.4px;left:1.9902%;width:109px;">
      <p class="g-pstyle5"><span class="g-cstyle9">U</span>. <span class="g-cstyle4">d</span>e A<span class="g-cstyle4">nt</span><span class="g-cstyle19">o</span><span class="g-cstyle4">f</span>ag<span class="g-cstyle4">as</span>ta<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-194" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.6459%;margin-top:-7.4px;left:21.3051%;width:65px;">
      <p class="g-pstyle5">Sant<span class="g-cstyle4">ia</span>go<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-195" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.6459%;margin-top:-7.4px;left:30.4861%;width:58px;">
      <p class="g-pstyle6"><span class="g-cstyle4">5</span>9<span class="g-cstyle4">1</span>,30<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-196" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.6459%;margin-top:-7.4px;left:38.4613%;width:61px;">
      <p class="g-pstyle6">6<span class="g-cstyle4">0</span><span class="g-cstyle22">4</span><span class="g-cstyle14">,</span>90<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-197" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.6459%;margin-top:-7.4px;left:46.5234%;width:60px;">
      <p class="g-pstyle6">686,<span class="g-cstyle4">40</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-198" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.6459%;margin-top:-7.4px;left:53.7526%;width:45px;">
      <p class="g-pstyle5">20%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-199" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.6459%;margin-top:-7.4px;left:58.6567%;width:45px;">
      <p class="g-pstyle5">3<span class="g-cstyle4">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-200" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.6459%;margin-top:-7.4px;left:63.6005%;width:43px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>0%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-201" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.6459%;margin-top:-7.4px;left:68.4964%;width:43px;">
      <p class="g-pstyle9">10<span class="g-cstyle6">%</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-202" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.6459%;margin-top:-7.4px;left:73.7181%;width:43px;">
      <p class="g-pstyle9">10<span class="g-cstyle6">%</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-203" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.6459%;margin-top:-7.4px;left:79.9315%;width:46px;">
      <p class="g-pstyle6">3<span class="g-cstyle4">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-204" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.6459%;margin-top:-7.4px;left:87.4145%;width:38px;">
      <p class="g-pstyle8"><span class="g-cstyle6">5</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-205" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.6459%;margin-top:-7.4px;left:93.0376%;width:82px;">
      <p class="g-pstyle8">$<span class="g-cstyle7">7</span><span class="g-cstyle6">.</span>5<span class="g-cstyle6">9</span><span class="g-cstyle21">9</span><span class="g-cstyle8">.</span>0<span class="g-cstyle6">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-206" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:69.924%;margin-top:-7.4px;left:1.9902%;width:132px;">
      <p class="g-pstyle5"><span class="g-cstyle9">U</span>. Aut<span class="g-cstyle4">ó</span>n<span class="g-cstyle4">o</span>m<span class="g-cstyle4">a</span> d<span class="g-cstyle4">e</span> C<span class="g-cstyle4">h</span>i<span class="g-cstyle4">l</span>e<span class="g-cstyle4">*</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-207" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.8178%;margin-top:-7.4px;left:21.0591%;width:70px;">
      <p class="g-pstyle5">La<span class="g-cstyle4"> </span>S<span class="g-cstyle4">e</span><span class="g-cstyle22">r</span><span class="g-cstyle4">e</span>na<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-208" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.8178%;margin-top:-7.4px;left:30.4306%;width:60px;">
      <p class="g-pstyle6"><span class="g-cstyle4">5</span>8<span class="g-cstyle5">8</span>,80<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-209" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.8178%;margin-top:-7.4px;left:38.5563%;width:58px;">
      <p class="g-pstyle6">672<span class="g-cstyle14">,</span>9<span class="g-cstyle4">7</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-210" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.8178%;margin-top:-7.4px;left:46.6267%;width:58px;">
      <p class="g-pstyle6">73<span class="g-cstyle11">9</span><span class="g-cstyle10">,</span>7<span class="g-cstyle4">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-211" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.8178%;margin-top:-7.4px;left:53.8322%;width:43px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-212" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.8178%;margin-top:-7.4px;left:58.6884%;width:45px;">
      <p class="g-pstyle5">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-213" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.8178%;margin-top:-7.4px;left:69.4807%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-214" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.8178%;margin-top:-7.4px;left:73.6703%;width:45px;">
      <p class="g-pstyle5">2<span class="g-cstyle4">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-215" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.8178%;margin-top:-7.4px;left:79.9235%;width:46px;">
      <p class="g-pstyle6">2<span class="g-cstyle4">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-216" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.8178%;margin-top:-7.4px;left:87.3986%;width:38px;">
      <p class="g-pstyle8"><span class="g-cstyle6">6</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-217" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.8178%;margin-top:-7.4px;left:92.9107%;width:84px;">
      <p class="g-pstyle8">$<span class="g-cstyle6">5</span>.<span class="g-cstyle6">5</span>0<span class="g-cstyle8">0.</span>00<span class="g-cstyle6">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-218" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.8178%;margin-top:-7.4px;left:63.5529%;width:45px;">
      <p class="g-pstyle5">20%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-219" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:74.0959%;margin-top:-7.4px;left:1.9902%;width:99px;">
      <p class="g-pstyle5"><span class="g-cstyle9">U</span>. <span class="g-cstyle4">d</span>e L<span class="g-cstyle4">a</span> <span class="g-cstyle4">Se</span><span class="g-cstyle19">r</span><span class="g-cstyle4">e</span>n<span class="g-cstyle4">a</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-220" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.9897%;margin-top:-7.4px;left:21.5748%;width:58px;">
      <p class="g-pstyle9"><span class="g-cstyle6">Iq</span>ui<span class="g-cstyle6">q</span>ue<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-221" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.9897%;margin-top:-7.4px;left:30.4544%;width:59px;">
      <p class="g-pstyle8">5<span class="g-cstyle6">6</span>1<span class="g-cstyle22">,</span>0<span class="g-cstyle6">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-222" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.9897%;margin-top:-7.4px;left:38.4533%;width:61px;">
      <p class="g-pstyle6">6<span class="g-cstyle4">4</span>6<span class="g-cstyle8">,</span>0<span class="g-cstyle4">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-223" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.9897%;margin-top:-7.4px;left:46.579%;width:59px;">
      <p class="g-pstyle6">73<span class="g-cstyle4">2</span><span class="g-cstyle22">,</span><span class="g-cstyle4">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-224" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.9897%;margin-top:-7.4px;left:53.8322%;width:43px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-225" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.9897%;margin-top:-7.4px;left:58.7281%;width:43px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-226" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.9897%;margin-top:-7.4px;left:63.6005%;width:43px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>0%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-227" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.9897%;margin-top:-7.4px;left:69.4807%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-228" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.9897%;margin-top:-7.4px;left:73.7181%;width:43px;">
      <p class="g-pstyle9">10<span class="g-cstyle6">%</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-229" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.9897%;margin-top:-7.4px;left:79.9315%;width:46px;">
      <p class="g-pstyle6">5<span class="g-cstyle4">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-230" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.9897%;margin-top:-7.4px;left:87.3828%;width:38px;">
      <p class="g-pstyle8"><span class="g-cstyle6">4</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-231" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.9897%;margin-top:-7.4px;left:93.0218%;width:81px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span>3<span class="g-cstyle8">.</span><span class="g-cstyle10">7</span>48.<span class="g-cstyle4">4</span>6<span class="g-cstyle4">5</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-232" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:78.2678%;margin-top:-7.4px;left:1.9902%;width:89px;">
      <p class="g-pstyle5"><span class="g-cstyle9">U</span>. Artu<span class="g-cstyle19">r</span><span class="g-cstyle4">o P</span>r<span class="g-cstyle19">a</span><span class="g-cstyle4">t</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-233" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:82.1616%;margin-top:-7.4px;left:21.3051%;width:65px;">
      <p class="g-pstyle5">Sant<span class="g-cstyle4">ia</span>go<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-234" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:82.1616%;margin-top:-7.4px;left:30.4068%;width:61px;">
      <p class="g-pstyle6"><span class="g-cstyle4">5</span>4<span class="g-cstyle14">0</span><span class="g-cstyle22">,</span><span class="g-cstyle4">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-235" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:82.1616%;margin-top:-7.4px;left:38.493%;width:59px;">
      <p class="g-pstyle8"><span class="g-cstyle6">6</span>1<span class="g-cstyle8">4</span><span class="g-cstyle22">,</span>0<span class="g-cstyle6">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-236" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:82.1616%;margin-top:-7.4px;left:46.5631%;width:60px;">
      <p class="g-pstyle6">73<span class="g-cstyle20">0</span><span class="g-cstyle8">,</span>0<span class="g-cstyle4">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-237" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:82.1616%;margin-top:-7.4px;left:53.8002%;width:43px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>0%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-238" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:82.1616%;margin-top:-7.4px;left:58.7281%;width:43px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-239" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:82.1616%;margin-top:-7.4px;left:63.5846%;width:45px;">
      <p class="g-pstyle5">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-240" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:82.1616%;margin-top:-7.4px;left:69.4807%;width:25px;">
      <p class="g-pstyle7"> </p>
    </div>
    <div id="g-ai0-241" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:82.1616%;margin-top:-7.4px;left:73.7181%;width:43px;">
      <p class="g-pstyle9">10<span class="g-cstyle6">%</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-242" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:82.1616%;margin-top:-7.4px;left:79.8997%;width:47px;">
      <p class="g-pstyle6">4<span class="g-cstyle4">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-243" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:82.1616%;margin-top:-7.4px;left:87.1606%;width:42px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">5</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-244" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:82.1616%;margin-top:-7.4px;left:92.8869%;width:83px;">
      <p class="g-pstyle8">$<span class="g-cstyle6">8</span><span class="g-cstyle8">.</span><span class="g-cstyle6">9</span>9<span class="g-cstyle21">9</span><span class="g-cstyle8">.</span>0<span class="g-cstyle6">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-245" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:82.4397%;margin-top:-7.4px;left:1.9902%;width:96px;">
      <p class="g-pstyle5"><span class="g-cstyle9">U</span>. And<span class="g-cstyle19">r</span>é<span class="g-cstyle4">s</span> <span class="g-cstyle4">B</span>e<span class="g-cstyle4">ll</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-246" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:86.3334%;margin-top:-7.4px;left:68.4964%;width:41px;">
      <p class="g-pstyle9">10<span class="g-cstyle1">%</span></p>
    </div>
    <div id="g-ai0-247" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:86.3334%;margin-top:-7.4px;left:20.4163%;width:77px;">
      <p class="g-pstyle5"><span class="g-cstyle4">C</span>oncep<span class="g-cstyle4">ci</span>ó<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai0-248" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:86.3334%;margin-top:-7.4px;left:30.4703%;width:56px;">
      <p class="g-pstyle8">5<span class="g-cstyle6">2</span>1<span class="g-cstyle22">,</span>0<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai0-249" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:86.3334%;margin-top:-7.4px;left:38.493%;width:57px;">
      <p class="g-pstyle6">6<span class="g-cstyle4">1</span><span class="g-cstyle20">0</span><span class="g-cstyle8">,</span>0<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai0-250" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:86.3334%;margin-top:-7.4px;left:46.5869%;width:56px;">
      <p class="g-pstyle6">7<span class="g-cstyle4">1</span><span class="g-cstyle20">0</span><span class="g-cstyle8">,</span>0<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai0-251" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:86.3334%;margin-top:-7.4px;left:53.8322%;width:41px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>5<span class="g-cstyle1">%</span></p>
    </div>
    <div id="g-ai0-252" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:86.3334%;margin-top:-7.4px;left:58.6884%;width:42px;">
      <p class="g-pstyle5">25<span class="g-cstyle1">%</span></p>
    </div>
    <div id="g-ai0-253" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:86.3334%;margin-top:-7.4px;left:63.6005%;width:41px;">
      <p class="g-pstyle5"><span class="g-cstyle4">1</span>0<span class="g-cstyle1">%</span></p>
    </div>
    <div id="g-ai0-254" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:86.3334%;margin-top:-7.4px;left:73.7102%;width:42px;">
      <p class="g-pstyle5">25<span class="g-cstyle1">%</span></p>
    </div>
    <div id="g-ai0-255" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:86.3334%;margin-top:-7.4px;left:79.9553%;width:44px;">
      <p class="g-pstyle8"><span class="g-cstyle6">2</span>5<span class="g-cstyle1">%</span></p>
    </div>
    <div id="g-ai0-256" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:86.3334%;margin-top:-7.4px;left:87.1289%;width:41px;">
      <p class="g-pstyle6">13<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai0-257" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:86.3334%;margin-top:-7.4px;left:93.1011%;width:79px;">
      <p class="g-pstyle6"><span class="g-cstyle4">$</span><span class="g-cstyle7">7</span><span class="g-cstyle8">.</span>625.30<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai0-258" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:86.3334%;margin-top:-7.4px;left:1.9902%;width:107px;">
      <p class="g-pstyle5"><span class="g-cstyle9">U</span>. San <span class="g-cstyle4">S</span>eb<span class="g-cstyle4">a</span>st<span class="g-cstyle4">iá</span>n<span class="g-cstyle1">*</span></p>
    </div>
    <div id="g-ai0-259" class="g-Layer_1 g-aiAbs" style="top:90.6689%;left:1.8085%;width:95.9574%;">
      <p class="g-pstyle11">Fuente: Información proporcionada por cada casa de estudio, la cual corresponde a la jornada diurna / En algunos casos los aranceles y vacantes corresponden al año 2021 / (*) Piden una de las dos pruebas optativas</p>
    </div>
  </div>

  <!-- Artboard: mobile -->
  <div id="g-odontologia-mobile" class="g-artboard" style="max-width: 320px;max-height: 1129px" data-aspect-ratio="0.283" data-min-width="0" data-max-width="939">
<div style="padding: 0 0 352.8125% 0;"></div>
    <img id="g-odontologia-mobile-img" class="g-aiImg" alt="" src="${img1}"/>
    <div id="g-ai1-1" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:2.4181%;margin-top:-12.3px;left:71.2366%;width:45px;">
      <p class="g-pstyle0">Prom</p>
      <p class="g-pstyle0">P<span class="g-cstyle0">o</span>n<span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai1-2" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:2.7204%;margin-top:-8.7px;left:1.9003%;width:91px;">
      <p class="g-pstyle1"><span class="g-cstyle0">U</span>ni<span class="g-cstyle0">ve</span>r<span class="g-cstyle0">s</span>i<span class="g-cstyle0">d</span>a<span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai1-3" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:2.7999%;margin-top:-6.6px;left:40.8981%;width:45px;">
      <p class="g-pstyle0">Sed<span class="g-cstyle1">e</span></p>
    </div>
    <div id="g-ai1-4" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:2.7999%;margin-top:-6.6px;left:54.4839%;width:63px;">
      <p class="g-pstyle0">M<span class="g-cstyle2">í</span>n <span class="g-cstyle0">P</span>on<span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai1-5" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:2.7999%;margin-top:-6.6px;left:82.7277%;width:65px;">
      <p class="g-pstyle0">M<span class="g-cstyle0">á</span>x Po<span class="g-cstyle0">n</span><span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai1-6" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:5.0852%;margin-top:-7.4px;left:1.7838%;width:87px;">
      <p class="g-pstyle2"><span class="g-cstyle3">P</span>UC <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>C<span class="g-cstyle3">h</span>il<span class="g-cstyle3">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-7" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:5.0852%;margin-top:-7.4px;left:38.5211%;width:65px;">
      <p class="g-pstyle2">Sant<span class="g-cstyle3">ia</span>go<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-8" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:5.0852%;margin-top:-7.4px;left:56.1621%;width:57px;">
      <p class="g-pstyle3">72<span class="g-cstyle3">1</span>,<span class="g-cstyle3">5</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-9" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:5.0852%;margin-top:-7.4px;left:70.5173%;width:58px;">
      <p class="g-pstyle3">73<span class="g-cstyle4">8</span>,<span class="g-cstyle3">57</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-10" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:5.0852%;margin-top:-7.4px;left:84.8718%;width:58px;">
      <p class="g-pstyle3">77<span class="g-cstyle3">5</span>,3<span class="g-cstyle3">5</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-11" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:6.4138%;margin-top:-7.4px;left:1.7838%;width:76px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">d</span>e C<span class="g-cstyle3">h</span>il<span class="g-cstyle3">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-12" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:6.4138%;margin-top:-7.4px;left:38.5211%;width:65px;">
      <p class="g-pstyle2">Sant<span class="g-cstyle3">ia</span>go<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-13" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:6.4138%;margin-top:-7.4px;left:55.976%;width:60px;">
      <p class="g-pstyle3">69<span class="g-cstyle3">5</span>,<span class="g-cstyle3">2</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-14" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:6.4138%;margin-top:-7.4px;left:70.5405%;width:56px;">
      <p class="g-pstyle4"><span class="g-cstyle6">7</span>11<span class="g-cstyle6">,</span>54<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-15" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:6.4138%;margin-top:-7.4px;left:84.5917%;width:60px;">
      <p class="g-pstyle4"><span class="g-cstyle7">7</span>4<span class="g-cstyle8">9</span><span class="g-cstyle9">,</span>0<span class="g-cstyle6">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-16" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:7.7424%;margin-top:-7.4px;left:1.7838%;width:77px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">d</span>e <span class="g-cstyle10">T</span><span class="g-cstyle3">a</span>lc<span class="g-cstyle3">a</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-17" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.7424%;margin-top:-7.4px;left:40.9451%;width:49px;">
      <p class="g-pstyle2"><span class="g-cstyle11">T</span>a<span class="g-cstyle3">l</span>ca<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-18" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.7424%;margin-top:-7.4px;left:55.9991%;width:59px;">
      <p class="g-pstyle3">69<span class="g-cstyle3">1</span>,<span class="g-cstyle3">8</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-19" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.7424%;margin-top:-7.4px;left:70.6802%;width:54px;">
      <p class="g-pstyle4"><span class="g-cstyle6">7</span>15<span class="g-cstyle6">,</span>11<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-20" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.7424%;margin-top:-7.4px;left:84.7314%;width:59px;">
      <p class="g-pstyle3"><span class="g-cstyle7">7</span><span class="g-cstyle3">4</span><span class="g-cstyle4">3</span><span class="g-cstyle12">,</span>95<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-21" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:8.9824%;margin-top:-7.4px;left:1.7838%;width:99px;">
      <p class="g-pstyle5">U. de Valparaíso*</p>
    </div>
    <div id="g-ai1-22" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.071%;margin-top:-7.4px;left:36.9586%;width:70px;">
      <p class="g-pstyle2">Valparaíso</p>
    </div>
    <div id="g-ai1-23" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.071%;margin-top:-7.4px;left:55.976%;width:56px;">
      <p class="g-pstyle3">691.40</p>
    </div>
    <div id="g-ai1-24" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.071%;margin-top:-7.4px;left:70.3772%;width:55px;">
      <p class="g-pstyle3">713.90</p>
    </div>
    <div id="g-ai1-25" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.071%;margin-top:-7.4px;left:84.6848%;width:57px;">
      <p class="g-pstyle3">764.30</p>
    </div>
    <div id="g-ai1-26" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.311%;margin-top:-7.4px;left:38.5211%;width:65px;">
      <p class="g-pstyle2">Sant<span class="g-cstyle3">ia</span>go<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-27" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.311%;margin-top:-7.4px;left:55.976%;width:60px;">
      <p class="g-pstyle3">68<span class="g-cstyle3">5</span><span class="g-cstyle13">,</span>90<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-28" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.311%;margin-top:-7.4px;left:70.3772%;width:58px;">
      <p class="g-pstyle4"><span class="g-cstyle6">7</span>0<span class="g-cstyle4">8</span><span class="g-cstyle9">,</span><span class="g-cstyle6">0</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-29" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.311%;margin-top:-7.4px;left:84.6848%;width:60px;">
      <p class="g-pstyle4"><span class="g-cstyle6">7</span>55<span class="g-cstyle9">,</span><span class="g-cstyle6">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-30" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:10.311%;margin-top:-7.4px;left:1.7838%;width:98px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">d</span>e <span class="g-cstyle3">lo</span>s <span class="g-cstyle3">A</span>n<span class="g-cstyle3">d</span>e<span class="g-cstyle3">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-31" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.6396%;margin-top:-7.4px;left:35.9103%;width:79px;">
      <p class="g-pstyle2"><span class="g-cstyle3">C</span>oncep<span class="g-cstyle3">ci</span>ón<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-32" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.6396%;margin-top:-7.4px;left:56.1389%;width:58px;">
      <p class="g-pstyle3">67<span class="g-cstyle3">5</span>,<span class="g-cstyle3">1</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-33" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.6396%;margin-top:-7.4px;left:70.2838%;width:60px;">
      <p class="g-pstyle3">696,<span class="g-cstyle3">8</span>3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-34" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.6396%;margin-top:-7.4px;left:84.7079%;width:58px;">
      <p class="g-pstyle4"><span class="g-cstyle7">7</span>4<span class="g-cstyle14">7</span><span class="g-cstyle6">,</span>40<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-35" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:11.6397%;margin-top:-7.4px;left:1.7838%;width:108px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">d</span>e C<span class="g-cstyle3">o</span>n<span class="g-cstyle3">c</span>epc<span class="g-cstyle3">ió</span>n<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-36" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:12.9683%;margin-top:-7.4px;left:38.7772%;width:61px;">
      <p class="g-pstyle2"><span class="g-cstyle15">T</span>em<span class="g-cstyle3">u</span>c<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-37" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:12.9683%;margin-top:-7.4px;left:56.1624%;width:59px;">
      <p class="g-pstyle3">6<span class="g-cstyle3">4</span><span class="g-cstyle14">7</span>,35<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-38" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:12.9683%;margin-top:-7.4px;left:70.3772%;width:59px;">
      <p class="g-pstyle3">675<span class="g-cstyle9">,</span><span class="g-cstyle3">0</span>2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-39" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:12.9683%;margin-top:-7.4px;left:84.7784%;width:59px;">
      <p class="g-pstyle3">73<span class="g-cstyle3">2</span><span class="g-cstyle12">,</span>9<span class="g-cstyle3">5</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-40" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:12.9683%;margin-top:-7.4px;left:1.7838%;width:106px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">d</span>e L<span class="g-cstyle3">a</span> <span class="g-cstyle16">F</span><span class="g-cstyle17">r</span><span class="g-cstyle3">on</span>te<span class="g-cstyle3">ra</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-41" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.2969%;margin-top:-7.4px;left:38.5211%;width:65px;">
      <p class="g-pstyle2">Sant<span class="g-cstyle3">ia</span>go<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-42" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.2969%;margin-top:-7.4px;left:56.0223%;width:60px;">
      <p class="g-pstyle3">63<span class="g-cstyle3">5</span>,<span class="g-cstyle3">2</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-43" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.2969%;margin-top:-7.4px;left:70.4938%;width:57px;">
      <p class="g-pstyle3">671<span class="g-cstyle7">,</span>70<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-44" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.2969%;margin-top:-7.4px;left:84.7546%;width:59px;">
      <p class="g-pstyle3">73<span class="g-cstyle3">5</span>,<span class="g-cstyle3">5</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-45" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:14.2969%;margin-top:-7.4px;left:1.7838%;width:107px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">d</span>el De<span class="g-cstyle3">s</span>a<span class="g-cstyle3">r</span><span class="g-cstyle17">r</span><span class="g-cstyle3">o</span>ll<span class="g-cstyle3">o*</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-46" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:15.6255%;margin-top:-7.4px;left:39.3365%;width:60px;">
      <p class="g-pstyle2"><span class="g-cstyle5">V</span>a<span class="g-cstyle3">l</span>div<span class="g-cstyle3">ia</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-47" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:15.6255%;margin-top:-7.4px;left:56.1154%;width:58px;">
      <p class="g-pstyle3">63<span class="g-cstyle9">4</span>,<span class="g-cstyle3">15</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-48" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:15.6255%;margin-top:-7.4px;left:70.2838%;width:59px;">
      <p class="g-pstyle3">67<span class="g-cstyle18">0</span>,<span class="g-cstyle3">4</span>2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-49" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:15.6255%;margin-top:-7.4px;left:84.6616%;width:59px;">
      <p class="g-pstyle3">73<span class="g-cstyle8">9</span>,8<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-50" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:15.6255%;margin-top:-7.4px;left:1.7838%;width:111px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. Aust<span class="g-cstyle3">r</span>a<span class="g-cstyle3">l </span>d<span class="g-cstyle3">e</span> C<span class="g-cstyle3">h</span>il<span class="g-cstyle3">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-51" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.9541%;margin-top:-7.4px;left:38.5211%;width:65px;">
      <p class="g-pstyle2">Sant<span class="g-cstyle3">ia</span>go<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-52" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.9541%;margin-top:-7.4px;left:55.976%;width:60px;">
      <p class="g-pstyle4"><span class="g-cstyle6">6</span>0<span class="g-cstyle6">6,</span>25<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-53" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.9541%;margin-top:-7.4px;left:70.3537%;width:60px;">
      <p class="g-pstyle3">6<span class="g-cstyle3">5</span><span class="g-cstyle4">3</span><span class="g-cstyle9">,</span>66<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-54" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.9541%;margin-top:-7.4px;left:84.8486%;width:56px;">
      <p class="g-pstyle4"><span class="g-cstyle6">7</span>1<span class="g-cstyle4">3</span><span class="g-cstyle6">,</span>10<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-55" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:16.9541%;margin-top:-7.4px;left:1.7838%;width:72px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">M</span>ay<span class="g-cstyle3">o</span>r*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-56" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.1942%;margin-top:-7.4px;left:38.5211%;width:65px;">
      <p class="g-pstyle2">Sant<span class="g-cstyle3">ia</span>go<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-57" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.1942%;margin-top:-7.4px;left:55.8826%;width:61px;">
      <p class="g-pstyle4"><span class="g-cstyle6">6</span>0<span class="g-cstyle4">3</span>,4<span class="g-cstyle6">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-58" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.1942%;margin-top:-7.4px;left:70.3772%;width:59px;">
      <p class="g-pstyle3">63<span class="g-cstyle4">8</span>,<span class="g-cstyle3">52</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-59" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.1942%;margin-top:-7.4px;left:84.5218%;width:60px;">
      <p class="g-pstyle3">68<span class="g-cstyle3">5</span>,<span class="g-cstyle3">4</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-60" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:18.2827%;margin-top:-7.4px;left:1.7838%;width:106px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. Die<span class="g-cstyle3">go</span> P<span class="g-cstyle3">o</span>rt<span class="g-cstyle3">al</span>e<span class="g-cstyle3">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-61" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:19.5227%;margin-top:-7.4px;left:38.5211%;width:65px;">
      <p class="g-pstyle2">Sant<span class="g-cstyle3">ia</span>go<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-62" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:19.5227%;margin-top:-7.4px;left:55.9991%;width:59px;">
      <p class="g-pstyle4"><span class="g-cstyle6">6</span>0<span class="g-cstyle6">2,</span>10<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-63" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:19.5227%;margin-top:-7.4px;left:70.3073%;width:59px;">
      <p class="g-pstyle3">6<span class="g-cstyle3">2</span><span class="g-cstyle19">4</span><span class="g-cstyle3">,</span>23<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-64" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:19.5227%;margin-top:-7.4px;left:84.545%;width:60px;">
      <p class="g-pstyle3">7<span class="g-cstyle3">0</span><span class="g-cstyle18">0</span><span class="g-cstyle9">,</span>60<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-65" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:19.6113%;margin-top:-7.4px;left:1.7838%;width:91px;">
      <p class="g-pstyle6"><span class="g-cstyle5">U</span><span class="g-cstyle6">. </span>F<span class="g-cstyle6">in</span>is <span class="g-cstyle20">T</span>e<span class="g-cstyle6">rr</span>ae<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-66" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.8513%;margin-top:-7.4px;left:36.33%;width:80px;">
      <p class="g-pstyle2">Ant<span class="g-cstyle21">o</span>fa<span class="g-cstyle3">g</span>asta<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-67" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.8513%;margin-top:-7.4px;left:55.9525%;width:60px;">
      <p class="g-pstyle3"><span class="g-cstyle3">5</span>9<span class="g-cstyle3">2</span><span class="g-cstyle9">,</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-68" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.8513%;margin-top:-7.4px;left:70.2139%;width:60px;">
      <p class="g-pstyle3">69<span class="g-cstyle3">2</span><span class="g-cstyle9">,</span>0<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-69" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.8513%;margin-top:-7.4px;left:84.545%;width:60px;">
      <p class="g-pstyle4"><span class="g-cstyle7">7</span>4<span class="g-cstyle4">8</span><span class="g-cstyle9">,</span><span class="g-cstyle6">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-70" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:20.9399%;margin-top:-7.4px;left:1.7838%;width:109px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">d</span>e A<span class="g-cstyle3">nt</span><span class="g-cstyle17">o</span><span class="g-cstyle3">f</span>ag<span class="g-cstyle3">as</span>ta<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-71" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.18%;margin-top:-7.4px;left:38.5211%;width:65px;">
      <p class="g-pstyle2">Sant<span class="g-cstyle3">ia</span>go<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-72" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.18%;margin-top:-7.4px;left:56.1154%;width:58px;">
      <p class="g-pstyle3"><span class="g-cstyle3">5</span>9<span class="g-cstyle3">1</span>,30<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-73" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.18%;margin-top:-7.4px;left:70.1675%;width:61px;">
      <p class="g-pstyle3">6<span class="g-cstyle3">0</span><span class="g-cstyle19">4</span><span class="g-cstyle12">,</span>90<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-74" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.18%;margin-top:-7.4px;left:84.4751%;width:60px;">
      <p class="g-pstyle3">686,<span class="g-cstyle3">40</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-75" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:22.2685%;margin-top:-7.4px;left:1.7838%;width:132px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. Aut<span class="g-cstyle3">ó</span>n<span class="g-cstyle3">o</span>m<span class="g-cstyle3">a</span> d<span class="g-cstyle3">e</span> C<span class="g-cstyle3">h</span>i<span class="g-cstyle3">l</span>e<span class="g-cstyle3">*</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-76" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.5086%;margin-top:-7.4px;left:37.7985%;width:70px;">
      <p class="g-pstyle2">La<span class="g-cstyle3"> </span>S<span class="g-cstyle3">e</span><span class="g-cstyle19">r</span><span class="g-cstyle3">e</span>na<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-77" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.5086%;margin-top:-7.4px;left:55.9525%;width:60px;">
      <p class="g-pstyle3"><span class="g-cstyle3">5</span>8<span class="g-cstyle4">8</span>,80<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-78" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.5086%;margin-top:-7.4px;left:70.4468%;width:58px;">
      <p class="g-pstyle3">672<span class="g-cstyle12">,</span>9<span class="g-cstyle3">7</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-79" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.5086%;margin-top:-7.4px;left:84.7784%;width:58px;">
      <p class="g-pstyle3">73<span class="g-cstyle8">9</span><span class="g-cstyle7">,</span>7<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-80" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:23.5972%;margin-top:-7.4px;left:1.7838%;width:99px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">d</span>e L<span class="g-cstyle3">a</span> <span class="g-cstyle3">Se</span><span class="g-cstyle17">r</span><span class="g-cstyle3">e</span>n<span class="g-cstyle3">a</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-81" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.8372%;margin-top:-7.4px;left:39.3134%;width:58px;">
      <p class="g-pstyle6"><span class="g-cstyle6">Iq</span>ui<span class="g-cstyle6">q</span>ue<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-82" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.8372%;margin-top:-7.4px;left:56.0223%;width:59px;">
      <p class="g-pstyle4">5<span class="g-cstyle6">6</span>1<span class="g-cstyle19">,</span>0<span class="g-cstyle6">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-83" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.8372%;margin-top:-7.4px;left:70.144%;width:61px;">
      <p class="g-pstyle3">6<span class="g-cstyle3">4</span>6<span class="g-cstyle9">,</span>0<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-84" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.8372%;margin-top:-7.4px;left:84.6384%;width:59px;">
      <p class="g-pstyle3">73<span class="g-cstyle3">2</span><span class="g-cstyle19">,</span><span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-85" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:24.8372%;margin-top:-7.4px;left:1.7838%;width:89px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. Artu<span class="g-cstyle17">r</span><span class="g-cstyle3">o P</span>r<span class="g-cstyle17">a</span><span class="g-cstyle3">t</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-86" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.1658%;margin-top:-7.4px;left:38.5211%;width:65px;">
      <p class="g-pstyle2">Sant<span class="g-cstyle3">ia</span>go<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-87" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.1658%;margin-top:-7.4px;left:55.8826%;width:61px;">
      <p class="g-pstyle3"><span class="g-cstyle3">5</span>4<span class="g-cstyle12">0</span><span class="g-cstyle19">,</span><span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-88" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.1658%;margin-top:-7.4px;left:70.2606%;width:59px;">
      <p class="g-pstyle4"><span class="g-cstyle6">6</span>1<span class="g-cstyle9">4</span><span class="g-cstyle19">,</span>0<span class="g-cstyle6">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-89" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.1658%;margin-top:-7.4px;left:84.5917%;width:60px;">
      <p class="g-pstyle3">73<span class="g-cstyle18">0</span><span class="g-cstyle9">,</span>0<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-90" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:26.1658%;margin-top:-7.4px;left:1.7838%;width:96px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. And<span class="g-cstyle17">r</span>é<span class="g-cstyle3">s</span> <span class="g-cstyle3">B</span>e<span class="g-cstyle3">ll</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-91" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.4944%;margin-top:-7.4px;left:35.9103%;width:77px;">
      <p class="g-pstyle2"><span class="g-cstyle3">C</span>oncep<span class="g-cstyle3">ci</span>ó<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai1-92" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.4944%;margin-top:-7.4px;left:56.069%;width:56px;">
      <p class="g-pstyle4">5<span class="g-cstyle6">2</span>1<span class="g-cstyle19">,</span>0<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai1-93" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.4944%;margin-top:-7.4px;left:70.2606%;width:57px;">
      <p class="g-pstyle3">6<span class="g-cstyle3">1</span><span class="g-cstyle18">0</span><span class="g-cstyle9">,</span>0<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai1-94" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.4944%;margin-top:-7.4px;left:84.6616%;width:56px;">
      <p class="g-pstyle3">7<span class="g-cstyle3">1</span><span class="g-cstyle18">0</span><span class="g-cstyle9">,</span>0<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai1-95" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:27.4944%;margin-top:-7.4px;left:1.7838%;width:107px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. San <span class="g-cstyle3">S</span>eb<span class="g-cstyle3">a</span>st<span class="g-cstyle3">iá</span>n<span class="g-cstyle1">*</span></p>
    </div>
    <div id="g-ai1-96" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.5607%;margin-top:-6.6px;left:44.1949%;width:40px;">
      <p class="g-pstyle7"><span class="g-cstyle0">P</span>D<span class="g-cstyle1">T</span></p>
    </div>
    <div id="g-ai1-97" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.5607%;margin-top:-6.6px;left:50.0458%;width:24px;">
      <p class="g-pstyle8"> </p>
    </div>
    <div id="g-ai1-98" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.5607%;margin-top:-6.6px;left:55.4764%;width:40px;">
      <p class="g-pstyle7"><span class="g-cstyle0">P</span>D<span class="g-cstyle1">T</span></p>
    </div>
    <div id="g-ai1-99" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.5607%;margin-top:-6.6px;left:61.3266%;width:24px;">
      <p class="g-pstyle8"> </p>
    </div>
    <div id="g-ai1-100" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.5607%;margin-top:-6.6px;left:66.7334%;width:40px;">
      <p class="g-pstyle7"><span class="g-cstyle0">P</span>D<span class="g-cstyle1">T</span></p>
    </div>
    <div id="g-ai1-101" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.5607%;margin-top:-6.6px;left:72.5842%;width:24px;">
      <p class="g-pstyle8"> </p>
    </div>
    <div id="g-ai1-102" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.5607%;margin-top:-6.6px;left:78.0133%;width:40px;">
      <p class="g-pstyle7">PD<span class="g-cstyle1">T</span></p>
    </div>
    <div id="g-ai1-103" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.5607%;margin-top:-6.6px;left:83.8651%;width:24px;">
      <p class="g-pstyle8"> </p>
    </div>
    <div id="g-ai1-104" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:32.5607%;margin-top:-6.6px;left:89.5279%;width:44px;">
      <p class="g-pstyle0"> NE<span class="g-cstyle1">M</span></p>
    </div>
    <div id="g-ai1-105" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:33.367%;margin-top:-8.7px;left:1.9003%;width:91px;">
      <p class="g-pstyle1"><span class="g-cstyle0">U</span>ni<span class="g-cstyle0">ve</span>r<span class="g-cstyle0">s</span>i<span class="g-cstyle0">d</span>a<span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai1-106" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.535%;margin-top:-6.6px;left:44.0552%;width:41px;">
      <p class="g-pstyle0">len<span class="g-cstyle1">g</span></p>
    </div>
    <div id="g-ai1-107" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.535%;margin-top:-6.6px;left:55.6161%;width:39px;">
      <p class="g-pstyle9"><span class="g-cstyle22">m</span>a<span class="g-cstyle1">t</span></p>
    </div>
    <div id="g-ai1-108" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.535%;margin-top:-6.6px;left:66.7566%;width:41px;">
      <p class="g-pstyle0">cie<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai1-109" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.535%;margin-top:-6.6px;left:78.3633%;width:39px;">
      <p class="g-pstyle0">his<span class="g-cstyle1">t</span></p>
    </div>
    <div id="g-ai1-110" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:35.7318%;margin-top:-7.4px;left:1.7838%;width:87px;">
      <p class="g-pstyle2"><span class="g-cstyle3">P</span>UC <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>C<span class="g-cstyle3">h</span>il<span class="g-cstyle3">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-111" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.8204%;margin-top:-7.4px;left:44.288%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>0%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-112" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.8204%;margin-top:-7.4px;left:55.4059%;width:45px;">
      <p class="g-pstyle2">20%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-113" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.8204%;margin-top:-7.4px;left:66.7798%;width:45px;">
      <p class="g-pstyle2">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-114" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.8204%;margin-top:-7.4px;left:80.9744%;width:25px;">
      <p class="g-pstyle10"> </p>
    </div>
    <div id="g-ai1-115" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.8204%;margin-top:-7.4px;left:90.1566%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-116" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:37.0604%;margin-top:-7.4px;left:1.7838%;width:76px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">d</span>e C<span class="g-cstyle3">h</span>il<span class="g-cstyle3">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-117" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.1489%;margin-top:-7.4px;left:44.382%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-118" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.1489%;margin-top:-7.4px;left:55.4059%;width:45px;">
      <p class="g-pstyle2">20%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-119" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.1489%;margin-top:-7.4px;left:66.7798%;width:45px;">
      <p class="g-pstyle2">35%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-120" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.1489%;margin-top:-7.4px;left:80.9744%;width:25px;">
      <p class="g-pstyle10"> </p>
    </div>
    <div id="g-ai1-121" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.1489%;margin-top:-7.4px;left:90.2969%;width:43px;">
      <p class="g-pstyle6">10<span class="g-cstyle6">%</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-122" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:38.389%;margin-top:-7.4px;left:1.7838%;width:77px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">d</span>e <span class="g-cstyle10">T</span><span class="g-cstyle3">a</span>lc<span class="g-cstyle3">a</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-123" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.4776%;margin-top:-7.4px;left:44.288%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>0%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-124" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.4776%;margin-top:-7.4px;left:55.5222%;width:45px;">
      <p class="g-pstyle2">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-125" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.4776%;margin-top:-7.4px;left:66.9196%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-126" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.4776%;margin-top:-7.4px;left:80.9744%;width:25px;">
      <p class="g-pstyle10"> </p>
    </div>
    <div id="g-ai1-127" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.4776%;margin-top:-7.4px;left:90.2737%;width:45px;">
      <p class="g-pstyle2">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-128" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:39.629%;margin-top:-7.4px;left:1.7838%;width:99px;">
      <p class="g-pstyle5">U. de Valparaíso*</p>
    </div>
    <div id="g-ai1-129" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.7176%;margin-top:-7.4px;left:44.1483%;width:40px;">
      <p class="g-pstyle2">15%</p>
    </div>
    <div id="g-ai1-130" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.7176%;margin-top:-7.4px;left:55.5222%;width:40px;">
      <p class="g-pstyle2">15%</p>
    </div>
    <div id="g-ai1-131" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.7176%;margin-top:-7.4px;left:66.9196%;width:41px;">
      <p class="g-pstyle6">10%</p>
    </div>
    <div id="g-ai1-132" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.7176%;margin-top:-7.4px;left:78.1763%;width:41px;">
      <p class="g-pstyle6">10%</p>
    </div>
    <div id="g-ai1-133" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.7176%;margin-top:-7.4px;left:90.1566%;width:42px;">
      <p class="g-pstyle2">30%</p>
    </div>
    <div id="g-ai1-134" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.9576%;margin-top:-7.4px;left:44.382%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-135" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.9576%;margin-top:-7.4px;left:55.4291%;width:45px;">
      <p class="g-pstyle2">3<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-136" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.9576%;margin-top:-7.4px;left:66.9196%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-137" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.9576%;margin-top:-7.4px;left:80.9744%;width:25px;">
      <p class="g-pstyle10"> </p>
    </div>
    <div id="g-ai1-138" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.9576%;margin-top:-7.4px;left:90.1566%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-139" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:40.9576%;margin-top:-7.4px;left:1.7838%;width:98px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">d</span>e <span class="g-cstyle3">lo</span>s <span class="g-cstyle3">A</span>n<span class="g-cstyle3">d</span>e<span class="g-cstyle3">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-140" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.2862%;margin-top:-7.4px;left:44.2413%;width:45px;">
      <p class="g-pstyle2">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-141" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.2862%;margin-top:-7.4px;left:55.5222%;width:45px;">
      <p class="g-pstyle2">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-142" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.2862%;margin-top:-7.4px;left:66.8265%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>0%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-143" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.2862%;margin-top:-7.4px;left:80.9744%;width:25px;">
      <p class="g-pstyle10"> </p>
    </div>
    <div id="g-ai1-144" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.2862%;margin-top:-7.4px;left:90.39%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-145" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:42.2863%;margin-top:-7.4px;left:1.7838%;width:108px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">d</span>e C<span class="g-cstyle3">o</span>n<span class="g-cstyle3">c</span>epc<span class="g-cstyle3">ió</span>n<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-146" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.6149%;margin-top:-7.4px;left:44.382%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-147" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.6149%;margin-top:-7.4px;left:55.4291%;width:45px;">
      <p class="g-pstyle2">3<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-148" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.6149%;margin-top:-7.4px;left:66.8265%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>0%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-149" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.6149%;margin-top:-7.4px;left:80.9744%;width:25px;">
      <p class="g-pstyle10"> </p>
    </div>
    <div id="g-ai1-150" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.6149%;margin-top:-7.4px;left:90.2969%;width:43px;">
      <p class="g-pstyle6">10<span class="g-cstyle6">%</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-151" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:43.6148%;margin-top:-7.4px;left:1.7838%;width:106px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">d</span>e L<span class="g-cstyle3">a</span> <span class="g-cstyle16">F</span><span class="g-cstyle17">r</span><span class="g-cstyle3">on</span>te<span class="g-cstyle3">ra</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-152" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.9435%;margin-top:-7.4px;left:44.1483%;width:45px;">
      <p class="g-pstyle2">20%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-153" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.9435%;margin-top:-7.4px;left:55.5222%;width:45px;">
      <p class="g-pstyle2">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-154" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.9435%;margin-top:-7.4px;left:66.9196%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-155" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.9435%;margin-top:-7.4px;left:78.1763%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-156" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.9435%;margin-top:-7.4px;left:90.1566%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-157" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:44.9435%;margin-top:-7.4px;left:1.7838%;width:107px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">d</span>el De<span class="g-cstyle3">s</span>a<span class="g-cstyle3">r</span><span class="g-cstyle17">r</span><span class="g-cstyle3">o</span>ll<span class="g-cstyle3">o*</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-158" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.2721%;margin-top:-7.4px;left:44.1483%;width:45px;">
      <p class="g-pstyle2">20%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-159" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.2721%;margin-top:-7.4px;left:55.6387%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-160" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.2721%;margin-top:-7.4px;left:66.9196%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-161" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.2721%;margin-top:-7.4px;left:80.9744%;width:25px;">
      <p class="g-pstyle10"> </p>
    </div>
    <div id="g-ai1-162" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.2721%;margin-top:-7.4px;left:90.39%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-163" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:46.2721%;margin-top:-7.4px;left:1.7838%;width:111px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. Aust<span class="g-cstyle3">r</span>a<span class="g-cstyle3">l </span>d<span class="g-cstyle3">e</span> C<span class="g-cstyle3">h</span>il<span class="g-cstyle3">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-164" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.6007%;margin-top:-7.4px;left:78.0832%;width:43px;">
      <p class="g-pstyle6">10<span class="g-cstyle6">%</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-165" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.6007%;margin-top:-7.4px;left:44.1483%;width:45px;">
      <p class="g-pstyle2">20%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-166" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.6007%;margin-top:-7.4px;left:55.3592%;width:45px;">
      <p class="g-pstyle2">40%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-167" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.6007%;margin-top:-7.4px;left:66.8265%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>0%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-168" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.6007%;margin-top:-7.4px;left:90.2969%;width:43px;">
      <p class="g-pstyle6">10<span class="g-cstyle6">%</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-169" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:47.6007%;margin-top:-7.4px;left:1.7838%;width:72px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">M</span>ay<span class="g-cstyle3">o</span>r*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-170" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.8408%;margin-top:-7.4px;left:44.2413%;width:45px;">
      <p class="g-pstyle2">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-171" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.8408%;margin-top:-7.4px;left:55.3592%;width:45px;">
      <p class="g-pstyle2">40%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-172" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.8408%;margin-top:-7.4px;left:66.9196%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-173" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.8408%;margin-top:-7.4px;left:80.9744%;width:25px;">
      <p class="g-pstyle10"> </p>
    </div>
    <div id="g-ai1-174" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.8408%;margin-top:-7.4px;left:90.2969%;width:43px;">
      <p class="g-pstyle6">10<span class="g-cstyle6">%</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-175" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:48.9293%;margin-top:-7.4px;left:1.7838%;width:106px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. Die<span class="g-cstyle3">go</span> P<span class="g-cstyle3">o</span>rt<span class="g-cstyle3">al</span>e<span class="g-cstyle3">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-176" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.1693%;margin-top:-7.4px;left:44.1483%;width:45px;">
      <p class="g-pstyle2">20%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-177" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.1693%;margin-top:-7.4px;left:55.4291%;width:45px;">
      <p class="g-pstyle2">3<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-178" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.1693%;margin-top:-7.4px;left:66.9196%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-179" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.1693%;margin-top:-7.4px;left:80.9744%;width:25px;">
      <p class="g-pstyle10"> </p>
    </div>
    <div id="g-ai1-180" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.1693%;margin-top:-7.4px;left:90.2737%;width:45px;">
      <p class="g-pstyle2">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-181" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:50.2579%;margin-top:-7.4px;left:1.7838%;width:91px;">
      <p class="g-pstyle6"><span class="g-cstyle5">U</span><span class="g-cstyle6">. </span>F<span class="g-cstyle6">in</span>is <span class="g-cstyle20">T</span>e<span class="g-cstyle6">rr</span>ae<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-182" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.4979%;margin-top:-7.4px;left:44.1483%;width:45px;">
      <p class="g-pstyle2">20%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-183" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.4979%;margin-top:-7.4px;left:55.4059%;width:45px;">
      <p class="g-pstyle2">20%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-184" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.4979%;margin-top:-7.4px;left:66.8265%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>0%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-185" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.4979%;margin-top:-7.4px;left:80.9744%;width:25px;">
      <p class="g-pstyle10"> </p>
    </div>
    <div id="g-ai1-186" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.4979%;margin-top:-7.4px;left:90.2969%;width:43px;">
      <p class="g-pstyle6">10<span class="g-cstyle6">%</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-187" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:51.5865%;margin-top:-7.4px;left:1.7838%;width:109px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">d</span>e A<span class="g-cstyle3">nt</span><span class="g-cstyle17">o</span><span class="g-cstyle3">f</span>ag<span class="g-cstyle3">as</span>ta<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-188" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.8266%;margin-top:-7.4px;left:44.1483%;width:45px;">
      <p class="g-pstyle2">20%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-189" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.8266%;margin-top:-7.4px;left:55.4291%;width:45px;">
      <p class="g-pstyle2">3<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-190" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.8266%;margin-top:-7.4px;left:66.8265%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>0%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-191" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.8266%;margin-top:-7.4px;left:78.0832%;width:43px;">
      <p class="g-pstyle6">10<span class="g-cstyle6">%</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-192" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.8266%;margin-top:-7.4px;left:90.2969%;width:43px;">
      <p class="g-pstyle6">10<span class="g-cstyle6">%</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-193" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:52.9151%;margin-top:-7.4px;left:1.7838%;width:132px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. Aut<span class="g-cstyle3">ó</span>n<span class="g-cstyle3">o</span>m<span class="g-cstyle3">a</span> d<span class="g-cstyle3">e</span> C<span class="g-cstyle3">h</span>i<span class="g-cstyle3">l</span>e<span class="g-cstyle3">*</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-194" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.1551%;margin-top:-7.4px;left:44.382%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-195" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.1551%;margin-top:-7.4px;left:55.5222%;width:45px;">
      <p class="g-pstyle2">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-196" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.1551%;margin-top:-7.4px;left:80.9744%;width:25px;">
      <p class="g-pstyle10"> </p>
    </div>
    <div id="g-ai1-197" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.1551%;margin-top:-7.4px;left:90.1566%;width:45px;">
      <p class="g-pstyle2">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-198" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.1552%;margin-top:-7.4px;left:66.6867%;width:45px;">
      <p class="g-pstyle2">20%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-199" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:54.2438%;margin-top:-7.4px;left:1.7838%;width:99px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">d</span>e L<span class="g-cstyle3">a</span> <span class="g-cstyle3">Se</span><span class="g-cstyle17">r</span><span class="g-cstyle3">e</span>n<span class="g-cstyle3">a</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-200" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.4838%;margin-top:-7.4px;left:44.382%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-201" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.4838%;margin-top:-7.4px;left:55.6387%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-202" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.4838%;margin-top:-7.4px;left:66.8265%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>0%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-203" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.4838%;margin-top:-7.4px;left:80.9744%;width:25px;">
      <p class="g-pstyle10"> </p>
    </div>
    <div id="g-ai1-204" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.4838%;margin-top:-7.4px;left:90.2969%;width:43px;">
      <p class="g-pstyle6">10<span class="g-cstyle6">%</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-205" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:55.4838%;margin-top:-7.4px;left:1.7838%;width:89px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. Artu<span class="g-cstyle17">r</span><span class="g-cstyle3">o P</span>r<span class="g-cstyle17">a</span><span class="g-cstyle3">t</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-206" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.8124%;margin-top:-7.4px;left:44.288%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>0%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-207" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.8124%;margin-top:-7.4px;left:55.6387%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-208" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.8124%;margin-top:-7.4px;left:66.7798%;width:45px;">
      <p class="g-pstyle2">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-209" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.8124%;margin-top:-7.4px;left:80.9744%;width:25px;">
      <p class="g-pstyle10"> </p>
    </div>
    <div id="g-ai1-210" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.8124%;margin-top:-7.4px;left:90.2969%;width:43px;">
      <p class="g-pstyle6">10<span class="g-cstyle6">%</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-211" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:56.8124%;margin-top:-7.4px;left:1.7838%;width:96px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. And<span class="g-cstyle17">r</span>é<span class="g-cstyle3">s</span> <span class="g-cstyle3">B</span>e<span class="g-cstyle3">ll</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-212" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.141%;margin-top:-7.4px;left:78.0832%;width:41px;">
      <p class="g-pstyle6">10<span class="g-cstyle1">%</span></p>
    </div>
    <div id="g-ai1-213" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.141%;margin-top:-7.4px;left:44.382%;width:41px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>5<span class="g-cstyle1">%</span></p>
    </div>
    <div id="g-ai1-214" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.141%;margin-top:-7.4px;left:55.5222%;width:42px;">
      <p class="g-pstyle2">25<span class="g-cstyle1">%</span></p>
    </div>
    <div id="g-ai1-215" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.141%;margin-top:-7.4px;left:66.8265%;width:41px;">
      <p class="g-pstyle2"><span class="g-cstyle3">1</span>0<span class="g-cstyle1">%</span></p>
    </div>
    <div id="g-ai1-216" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:58.141%;margin-top:-7.4px;left:90.2737%;width:42px;">
      <p class="g-pstyle2">25<span class="g-cstyle1">%</span></p>
    </div>
    <div id="g-ai1-217" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:58.141%;margin-top:-7.4px;left:1.7838%;width:107px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. San <span class="g-cstyle3">S</span>eb<span class="g-cstyle3">a</span>st<span class="g-cstyle3">iá</span>n<span class="g-cstyle1">*</span></p>
    </div>
    <div id="g-ai1-218" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.0301%;margin-top:-6.6px;left:50.0003%;width:60px;">
      <p class="g-pstyle0"><span class="g-cstyle0">Ra</span>nkin<span class="g-cstyle0">g</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-219" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.0301%;margin-top:-6.6px;left:85.6165%;width:59px;">
      <p class="g-pstyle0">Ar<span class="g-cstyle0">a</span>nce<span class="g-cstyle0">l</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-220" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:63.8364%;margin-top:-8.7px;left:1.9003%;width:91px;">
      <p class="g-pstyle1"><span class="g-cstyle0">U</span>ni<span class="g-cstyle0">ve</span>r<span class="g-cstyle0">s</span>i<span class="g-cstyle0">d</span>a<span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai1-221" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.0045%;margin-top:-6.6px;left:63.6569%;width:64px;">
      <p class="g-pstyle0"><span class="g-cstyle0">V</span>acant<span class="g-cstyle0">e</span><span class="g-cstyle1">s</span></p>
    </div>
    <div id="g-ai1-222" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.0045%;margin-top:-6.6px;left:51.8652%;width:47px;">
      <p class="g-pstyle0">not<span class="g-cstyle0">a</span><span class="g-cstyle1">s</span></p>
    </div>
    <div id="g-ai1-223" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.0045%;margin-top:-6.6px;left:81.3971%;width:70px;">
      <p class="g-pstyle0">referen<span class="g-cstyle0">c</span>i<span class="g-cstyle0">a</span><span class="g-cstyle1">l</span></p>
    </div>
    <div id="g-ai1-224" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:66.2012%;margin-top:-7.4px;left:1.7838%;width:87px;">
      <p class="g-pstyle2"><span class="g-cstyle3">P</span>UC <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>C<span class="g-cstyle3">h</span>il<span class="g-cstyle3">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-225" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.2898%;margin-top:-7.4px;left:52.6813%;width:45px;">
      <p class="g-pstyle3">2<span class="g-cstyle3">5</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-226" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.2898%;margin-top:-7.4px;left:68.2959%;width:38px;">
      <p class="g-pstyle4"><span class="g-cstyle6">6</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-227" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.2898%;margin-top:-7.4px;left:78.7271%;width:81px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span><span class="g-cstyle23">7</span>.35<span class="g-cstyle3">2</span><span class="g-cstyle9">.</span>0<span class="g-cstyle3">00</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-228" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:67.5299%;margin-top:-7.4px;left:1.7838%;width:76px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">d</span>e C<span class="g-cstyle3">h</span>il<span class="g-cstyle3">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-229" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.6184%;margin-top:-7.4px;left:52.5879%;width:46px;">
      <p class="g-pstyle3">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-230" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.6184%;margin-top:-7.4px;left:67.4103%;width:43px;">
      <p class="g-pstyle4"><span class="g-cstyle6">1</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-231" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.6184%;margin-top:-7.4px;left:78.4705%;width:81px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span>6.<span class="g-cstyle3">4</span>16<span class="g-cstyle9">.</span><span class="g-cstyle3">7</span>0<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-232" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:68.8584%;margin-top:-7.4px;left:1.7838%;width:77px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">d</span>e <span class="g-cstyle10">T</span><span class="g-cstyle3">a</span>lc<span class="g-cstyle3">a</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-233" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:68.947%;margin-top:-7.4px;left:52.6813%;width:45px;">
      <p class="g-pstyle3">2<span class="g-cstyle3">5</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-234" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:68.947%;margin-top:-7.4px;left:68.3426%;width:38px;">
      <p class="g-pstyle4"><span class="g-cstyle6">5</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-235" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:68.947%;margin-top:-7.4px;left:78.5641%;width:83px;">
      <p class="g-pstyle4">$<span class="g-cstyle6">5</span>.<span class="g-cstyle6">5</span>5<span class="g-cstyle6">3</span><span class="g-cstyle9">.</span>0<span class="g-cstyle6">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-236" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:70.0985%;margin-top:-7.4px;left:1.7838%;width:99px;">
      <p class="g-pstyle5">U. de Valparaíso*</p>
    </div>
    <div id="g-ai1-237" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.1871%;margin-top:-7.4px;left:52.6813%;width:44px;">
      <p class="g-pstyle3">30%</p>
    </div>
    <div id="g-ai1-238" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.1871%;margin-top:-7.4px;left:68.3426%;width:34px;">
      <p class="g-pstyle3">72</p>
    </div>
    <div id="g-ai1-239" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.1871%;margin-top:-7.4px;left:78.5641%;width:81px;">
      <p class="g-pstyle4">$5.603.000</p>
    </div>
    <div id="g-ai1-240" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.4271%;margin-top:-7.4px;left:52.5879%;width:46px;">
      <p class="g-pstyle3">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-241" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.4271%;margin-top:-7.4px;left:68.3194%;width:37px;">
      <p class="g-pstyle4"><span class="g-cstyle6">4</span>2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-242" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.4271%;margin-top:-7.4px;left:85.6567%;width:58px;">
      <p class="g-pstyle3">287 <span class="g-cstyle3">U</span>F<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-243" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:71.4271%;margin-top:-7.4px;left:1.7838%;width:98px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">d</span>e <span class="g-cstyle3">lo</span>s <span class="g-cstyle3">A</span>n<span class="g-cstyle3">d</span>e<span class="g-cstyle3">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-244" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.7557%;margin-top:-7.4px;left:52.6813%;width:45px;">
      <p class="g-pstyle3">2<span class="g-cstyle3">5</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-245" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.7557%;margin-top:-7.4px;left:68.4598%;width:36px;">
      <p class="g-pstyle3">75<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-246" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.7557%;margin-top:-7.4px;left:78.634%;width:80px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span>6<span class="g-cstyle9">.</span>97<span class="g-cstyle3">6</span><span class="g-cstyle9">.</span><span class="g-cstyle3">01</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-247" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:72.7557%;margin-top:-7.4px;left:1.7838%;width:108px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">d</span>e C<span class="g-cstyle3">o</span>n<span class="g-cstyle3">c</span>epc<span class="g-cstyle3">ió</span>n<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-248" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:74.0843%;margin-top:-7.4px;left:52.7045%;width:46px;">
      <p class="g-pstyle3">3<span class="g-cstyle3">5</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-249" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:74.0843%;margin-top:-7.4px;left:68.3658%;width:37px;">
      <p class="g-pstyle3">70<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-250" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:74.0843%;margin-top:-7.4px;left:78.7503%;width:81px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span>5<span class="g-cstyle9">.</span>78<span class="g-cstyle23">7</span><span class="g-cstyle9">.</span><span class="g-cstyle3">00</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-251" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:74.0843%;margin-top:-7.4px;left:1.7838%;width:106px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">d</span>e L<span class="g-cstyle3">a</span> <span class="g-cstyle16">F</span><span class="g-cstyle17">r</span><span class="g-cstyle3">on</span>te<span class="g-cstyle3">ra</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-252" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:75.4129%;margin-top:-7.4px;left:52.5879%;width:46px;">
      <p class="g-pstyle3">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-253" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:75.4129%;margin-top:-7.4px;left:67.4103%;width:43px;">
      <p class="g-pstyle4"><span class="g-cstyle6">1</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-254" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:75.4129%;margin-top:-7.4px;left:84.7644%;width:59px;">
      <p class="g-pstyle3">3<span class="g-cstyle3">0</span>5 UF<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-255" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:75.4129%;margin-top:-7.4px;left:1.7838%;width:107px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">d</span>el De<span class="g-cstyle3">s</span>a<span class="g-cstyle3">r</span><span class="g-cstyle17">r</span><span class="g-cstyle3">o</span>ll<span class="g-cstyle3">o*</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-256" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:76.7415%;margin-top:-7.4px;left:52.7045%;width:46px;">
      <p class="g-pstyle3">3<span class="g-cstyle3">5</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-257" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:76.7415%;margin-top:-7.4px;left:68.3194%;width:37px;">
      <p class="g-pstyle3">66<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-258" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:76.7415%;margin-top:-7.4px;left:78.2843%;width:82px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span>6<span class="g-cstyle9">.</span><span class="g-cstyle3">0</span>16<span class="g-cstyle9">.</span><span class="g-cstyle3">00</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-259" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:76.7416%;margin-top:-7.4px;left:1.7838%;width:111px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. Aust<span class="g-cstyle3">r</span>a<span class="g-cstyle3">l </span>d<span class="g-cstyle3">e</span> C<span class="g-cstyle3">h</span>il<span class="g-cstyle3">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-260" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:78.0701%;margin-top:-7.4px;left:52.5879%;width:46px;">
      <p class="g-pstyle3">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-261" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:78.0701%;margin-top:-7.4px;left:68.2959%;width:38px;">
      <p class="g-pstyle4"><span class="g-cstyle6">6</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-262" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:78.0701%;margin-top:-7.4px;left:78.7735%;width:80px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span><span class="g-cstyle23">7</span><span class="g-cstyle9">.</span>9<span class="g-cstyle3">0</span><span class="g-cstyle24">9</span>.<span class="g-cstyle3">1</span>60<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-263" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:78.0702%;margin-top:-7.4px;left:1.7838%;width:72px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">M</span>ay<span class="g-cstyle3">o</span>r*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-264" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:79.3102%;margin-top:-7.4px;left:52.6578%;width:45px;">
      <p class="g-pstyle3">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-265" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:79.3102%;margin-top:-7.4px;left:68.3658%;width:37px;">
      <p class="g-pstyle4"><span class="g-cstyle6">6</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-266" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:79.3102%;margin-top:-7.4px;left:78.2144%;width:83px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span>8<span class="g-cstyle9">.</span>7<span class="g-cstyle3">0</span>8<span class="g-cstyle9">.</span><span class="g-cstyle3">0</span>0<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-267" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:79.3988%;margin-top:-7.4px;left:1.7838%;width:106px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. Die<span class="g-cstyle3">go</span> P<span class="g-cstyle3">o</span>rt<span class="g-cstyle3">al</span>e<span class="g-cstyle3">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-268" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:80.6388%;margin-top:-7.4px;left:52.6578%;width:45px;">
      <p class="g-pstyle3">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-269" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:80.6388%;margin-top:-7.4px;left:68.3426%;width:38px;">
      <p class="g-pstyle4"><span class="g-cstyle6">5</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-270" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:80.6388%;margin-top:-7.4px;left:78.1677%;width:84px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span>8.36<span class="g-cstyle16">0</span><span class="g-cstyle9">.</span><span class="g-cstyle3">0</span>0<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-271" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:80.7274%;margin-top:-7.4px;left:1.7838%;width:91px;">
      <p class="g-pstyle6"><span class="g-cstyle5">U</span><span class="g-cstyle6">. </span>F<span class="g-cstyle6">in</span>is <span class="g-cstyle20">T</span>e<span class="g-cstyle6">rr</span>ae<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-272" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:81.9674%;margin-top:-7.4px;left:52.518%;width:47px;">
      <p class="g-pstyle3">4<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-273" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:81.9674%;margin-top:-7.4px;left:68.2495%;width:38px;">
      <p class="g-pstyle4"><span class="g-cstyle6">4</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-274" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:81.9674%;margin-top:-7.4px;left:78.3075%;width:83px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span>5<span class="g-cstyle16">.</span>626<span class="g-cstyle9">.</span><span class="g-cstyle3">00</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-275" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:82.0559%;margin-top:-7.4px;left:1.7838%;width:109px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">d</span>e A<span class="g-cstyle3">nt</span><span class="g-cstyle17">o</span><span class="g-cstyle3">f</span>ag<span class="g-cstyle3">as</span>ta<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-276" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:83.296%;margin-top:-7.4px;left:52.6114%;width:46px;">
      <p class="g-pstyle3">3<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-277" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:83.296%;margin-top:-7.4px;left:68.3426%;width:38px;">
      <p class="g-pstyle4"><span class="g-cstyle6">5</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-278" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:83.296%;margin-top:-7.4px;left:78.6105%;width:82px;">
      <p class="g-pstyle4">$<span class="g-cstyle23">7</span><span class="g-cstyle6">.</span>5<span class="g-cstyle6">9</span><span class="g-cstyle24">9</span><span class="g-cstyle9">.</span>0<span class="g-cstyle6">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-279" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:83.3846%;margin-top:-7.4px;left:1.7838%;width:132px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. Aut<span class="g-cstyle3">ó</span>n<span class="g-cstyle3">o</span>m<span class="g-cstyle3">a</span> d<span class="g-cstyle3">e</span> C<span class="g-cstyle3">h</span>i<span class="g-cstyle3">l</span>e<span class="g-cstyle3">*</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-280" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:84.6246%;margin-top:-7.4px;left:52.5879%;width:46px;">
      <p class="g-pstyle3">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-281" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:84.6246%;margin-top:-7.4px;left:68.2959%;width:38px;">
      <p class="g-pstyle4"><span class="g-cstyle6">6</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-282" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:84.6246%;margin-top:-7.4px;left:78.2376%;width:84px;">
      <p class="g-pstyle4">$<span class="g-cstyle6">5</span>.<span class="g-cstyle6">5</span>0<span class="g-cstyle9">0.</span>00<span class="g-cstyle6">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-283" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:84.7132%;margin-top:-7.4px;left:1.7838%;width:99px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. <span class="g-cstyle3">d</span>e L<span class="g-cstyle3">a</span> <span class="g-cstyle3">Se</span><span class="g-cstyle17">r</span><span class="g-cstyle3">e</span>n<span class="g-cstyle3">a</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-284" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:85.9532%;margin-top:-7.4px;left:52.6114%;width:46px;">
      <p class="g-pstyle3">5<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-285" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:85.9532%;margin-top:-7.4px;left:68.2495%;width:38px;">
      <p class="g-pstyle4"><span class="g-cstyle6">4</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-286" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:85.9532%;margin-top:-7.4px;left:78.5641%;width:81px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span>3<span class="g-cstyle9">.</span><span class="g-cstyle7">7</span>48.<span class="g-cstyle3">4</span>6<span class="g-cstyle3">5</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-287" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:85.9532%;margin-top:-7.4px;left:1.7838%;width:89px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. Artu<span class="g-cstyle17">r</span><span class="g-cstyle3">o P</span>r<span class="g-cstyle17">a</span><span class="g-cstyle3">t</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-288" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:87.2819%;margin-top:-7.4px;left:52.518%;width:47px;">
      <p class="g-pstyle3">4<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-289" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:87.2819%;margin-top:-7.4px;left:67.5967%;width:42px;">
      <p class="g-pstyle3">1<span class="g-cstyle3">5</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-290" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:87.2819%;margin-top:-7.4px;left:78.1677%;width:83px;">
      <p class="g-pstyle4">$<span class="g-cstyle6">8</span><span class="g-cstyle9">.</span><span class="g-cstyle6">9</span>9<span class="g-cstyle24">9</span><span class="g-cstyle9">.</span>0<span class="g-cstyle6">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-291" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:87.2818%;margin-top:-7.4px;left:1.7838%;width:96px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. And<span class="g-cstyle17">r</span>é<span class="g-cstyle3">s</span> <span class="g-cstyle3">B</span>e<span class="g-cstyle3">ll</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-292" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:88.6105%;margin-top:-7.4px;left:52.6813%;width:44px;">
      <p class="g-pstyle4"><span class="g-cstyle6">2</span>5<span class="g-cstyle1">%</span></p>
    </div>
    <div id="g-ai1-293" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:88.6105%;margin-top:-7.4px;left:67.5037%;width:41px;">
      <p class="g-pstyle3">13<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai1-294" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:88.6105%;margin-top:-7.4px;left:78.797%;width:79px;">
      <p class="g-pstyle3"><span class="g-cstyle3">$</span><span class="g-cstyle23">7</span><span class="g-cstyle9">.</span>625.30<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai1-295" class="g-Layer_2 g-aiAbs g-aiPointText" style="top:88.6104%;margin-top:-7.4px;left:1.7838%;width:107px;">
      <p class="g-pstyle2"><span class="g-cstyle5">U</span>. San <span class="g-cstyle3">S</span>eb<span class="g-cstyle3">a</span>st<span class="g-cstyle3">iá</span>n<span class="g-cstyle1">*</span></p>
    </div>
    <div id="g-ai1-296" class="g-Layer_1 g-aiAbs" style="top:94.0655%;left:4.0625%;width:90.625%;">
      <p class="g-pstyle11">Fuente: Información proporcionada por cada casa de estudio, la cual corresponde a la jornada diurna / En algunos casos los aranceles y vacantes corresponden al año 2021 / (*) Piden una de las dos pruebas optativas</p>
    </div>
  </div>


</div>
`

const containerId = 'g-odontologia-box'
const namespace = 'g-'
const name = 'odontologia'

export default makeAi2React({ html, styles, containerId, namespace, name })

/* End ai2react - 2021-12-23 02:23 */
